webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);



Date.prototype.Format = function (fmt) {
  fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds() };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }
  return fmt;
};

Date.prototype.myUTCFormat = function (format) {
  format = format || 'yyyy-MM-ddThh:mm:ssZ';
  var timeFormat = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': format === 'yyyy-MM-ddThh:mm:ssZ' ? this.getHours() - 8 : this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds() };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in timeFormat) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? timeFormat[k] : ('00' + timeFormat[k]).substr(('' + timeFormat[k]).length));
    }
  }
  return format;
};


/* harmony default export */ __webpack_exports__["a"] = ({
  urlParam: function urlParam(url) {
    var regex = /([^&=?]+)=([^&=?]+)/g,
        obj = {};
    url.replace(regex, function () {
      for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      obj[arg[1]] = decodeURIComponent(arg[2]);
    });
    return obj || '';
  },

  parseSpace: function parseSpace(value) {
    if (!value) return value;
    return value.replace(/[\r\n]/g, '<br>').replace(/[\s\t\b]/g, '&nbsp;');
  },

  parseCount: function parseCount(num) {
    if (!isNaN(num) && num) {
      if (num >= 10000) {
        try {
          var curNum = (parseInt(num / 1000) / 10).toFixed(1).replace(/\.0$/, '');
          return isNaN(curNum) ? num : curNum + '万';
        } catch (e) {
          return (num + '').replace(/\.0$/, '');
        }
      } else {
        return (num + '').replace(/\.0$/, '');
      }
    } else {
      return 0;
    }
  },

  parseDateTime: function parseDateTime(hisTime) {
    if (!arguments.length) return '';
    try {
      var arg = arguments,
          now = arg[1] ? arg[1] : new Date().getTime(),
          diffValue = now - new Date(arg[0].replace(/-/g, '/')).getTime(),
          cur = new Date(arg[0].replace(/-/g, '/')).getTime(),
          result = '',
          minute = 1000 * 60,
          hour = minute * 60,
          day = hour * 24,
          halfamonth = day * 15,
          month = day * 30,
          year = month * 12,
          _year = diffValue / year,
          _month = diffValue / month,
          _week = diffValue / (7 * day),
          _day = diffValue / day,
          _hour = diffValue / hour,
          _min = diffValue / minute;

      if (new Date(cur).getFullYear() == new Date().getFullYear()) {
        if (_month >= 1 || _week >= 1 || _day >= 3) {
          result = new Date(cur).Format('MM-dd');
        } else if (_day >= 1) {
          result = parseInt(_day) + '天前';
        } else if (_hour >= 1) {
          result = parseInt(_hour) + '小时前';
        } else if (_min >= 1) {
          result = parseInt(_min) + '分钟前';
        } else {
          result = '刚刚';
        }
        return result;
      } else {
        return new Date(cur).Format('yyyy-MM-dd');
      }
    } catch (e) {
      return hisTime;
    }
  },

  getUrlParam: function getUrlParam(param) {
    var sValue = window.location.href.match(new RegExp('[\?\&]' + param + '=([^\&]*)(\&?)', 'i'));
    return sValue ? sValue[1] : sValue;
  },
  SHA_UUID_MD: {
    HEX_SHA1: function HEX_SHA1(s) {
      var hexcase = 0;

      var b64pad = '';

      var chrsz = 8;

      function b64_sha1(s) {
        return binb2b64(core_sha1(str2binb(s), s.length * chrsz));
      }

      function str_sha1(s) {
        return binb2str(core_sha1(str2binb(s), s.length * chrsz));
      }

      function hex_hmac_sha1(key, data) {
        return binb2hex(core_hmac_sha1(key, data));
      }

      function b64_hmac_sha1(key, data) {
        return binb2b64(core_hmac_sha1(key, data));
      }

      function str_hmac_sha1(key, data) {
        return binb2str(core_hmac_sha1(key, data));
      }

      function sha1_vm_test() {
        return hex_sha1('abc') == 'a9993e364706816aba3e25717850c26c9cd0d89d';
      }

      function core_sha1(x, len) {
        x[len >> 5] |= 0x80 << 24 - len % 32;
        x[(len + 64 >> 9 << 4) + 15] = len;
        var w = Array(80);
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;
        var e = -1009589776;
        for (var i = 0; i < x.length; i += 16) {
          var olda = a;
          var oldb = b;
          var oldc = c;
          var oldd = d;
          var olde = e;
          for (var j = 0; j < 80; j++) {
            if (j < 16) {
              w[j] = x[i + j];
            } else {
              w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
            }
            var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));
            e = d;
            d = c;
            c = rol(b, 30);
            b = a;
            a = t;
          }
          a = safe_add(a, olda);
          b = safe_add(b, oldb);
          c = safe_add(c, oldc);
          d = safe_add(d, oldd);
          e = safe_add(e, olde);
        }

        return Array(a, b, c, d, e);
      }

      function sha1_ft(t, b, c, d) {
        if (t < 20) return b & c | ~b & d;
        if (t < 40) return b ^ c ^ d;
        if (t < 60) return b & c | b & d | c & d;
        return b ^ c ^ d;
      }

      function sha1_kt(t) {
        return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
      }

      function core_hmac_sha1(key, data) {
        var bkey = str2binb(key);
        if (bkey.length > 16) bkey = core_sha1(bkey, key.length * chrsz);

        var ipad = Array(16),
            opad = Array(16);
        for (var i = 0; i < 16; i++) {
          ipad[i] = bkey[i] ^ 0x36363636;
          opad[i] = bkey[i] ^ 0x5C5C5C5C;
        }
        var hash = core_sha1(ipad.concat(str2binb(data)), 512 + data.length * chrsz);
        return core_sha1(opad.concat(hash), 512 + 160);
      }

      function safe_add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
      }

      function rol(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
      }

      function str2binb(str) {
        var bin = Array();
        var mask = (1 << chrsz) - 1;
        for (var i = 0; i < str.length * chrsz; i += chrsz) {
          bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << 24 - i % 32;
        }
        return bin;
      }

      function binb2str(bin) {
        var str = '';
        var mask = (1 << chrsz) - 1;
        for (var i = 0; i < bin.length * 32; i += chrsz) {
          str += String.fromCharCode(bin[i >> 5] >>> 24 - i % 32 & mask);
        }
        return str;
      }

      function binb2hex(binarray) {
        var hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef';
        var str = '';
        for (var i = 0; i < binarray.length * 4; i++) {
          str += hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 & 0xF);
        }
        return str;
      }

      function binb2b64(binarray) {
        var tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        var str = '';
        for (var i = 0; i < binarray.length * 4; i += 3) {
          var triplet = (binarray[i >> 2] >> 8 * (3 - i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4) & 0xFF;
          for (var j = 0; j < 4; j++) {
            if (i * 8 + j * 6 > binarray.length * 32) {
              str += b64pad;
            } else {
              str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
            }
          }
        }
        return str;
      }

      return binb2hex(core_sha1(str2binb(s), s.length * chrsz));
    },
    UUID: function UUID() {
      var d = new Date().getTime();
      var _ss = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);

        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return _ss;
    },
    MD5: function MD5(string) {
      function md5_RotateLeft(lValue, iShiftBits) {
        return lValue << iShiftBits | lValue >>> 32 - iShiftBits;
      }

      function md5_AddUnsigned(lX, lY) {
        var lX4, lY4, lX8, lY8, lResult;
        lX8 = lX & 0x80000000;
        lY8 = lY & 0x80000000;
        lX4 = lX & 0x40000000;
        lY4 = lY & 0x40000000;
        lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
        if (lX4 & lY4) {
          return lResult ^ 0x80000000 ^ lX8 ^ lY8;
        }
        if (lX4 | lY4) {
          if (lResult & 0x40000000) {
            return lResult ^ 0xC0000000 ^ lX8 ^ lY8;
          } else {
            return lResult ^ 0x40000000 ^ lX8 ^ lY8;
          }
        } else {
          return lResult ^ lX8 ^ lY8;
        }
      }

      function md5_F(x, y, z) {
        return x & y | ~x & z;
      }

      function md5_G(x, y, z) {
        return x & z | y & ~z;
      }

      function md5_H(x, y, z) {
        return x ^ y ^ z;
      }

      function md5_I(x, y, z) {
        return y ^ (x | ~z);
      }

      function md5_FF(a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_F(b, c, d), x), ac));
        return md5_AddUnsigned(md5_RotateLeft(a, s), b);
      }

      function md5_GG(a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_G(b, c, d), x), ac));
        return md5_AddUnsigned(md5_RotateLeft(a, s), b);
      }

      function md5_HH(a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_H(b, c, d), x), ac));
        return md5_AddUnsigned(md5_RotateLeft(a, s), b);
      }

      function md5_II(a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_I(b, c, d), x), ac));
        return md5_AddUnsigned(md5_RotateLeft(a, s), b);
      }

      function md5_ConvertToWordArray(string) {
        var lWordCount;
        var lMessageLength = string.length;

        var lNumberOfWords_temp1 = lMessageLength + 8;

        var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - lNumberOfWords_temp1 % 64) / 64;

        var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
        var lWordArray = Array(lNumberOfWords - 1);
        var lBytePosition = 0;
        var lByteCount = 0;
        while (lByteCount < lMessageLength) {
          lWordCount = (lByteCount - lByteCount % 4) / 4;
          lBytePosition = lByteCount % 4 * 8;
          lWordArray[lWordCount] = lWordArray[lWordCount] | string.charCodeAt(lByteCount) << lBytePosition;
          lByteCount++;
        }
        lWordCount = (lByteCount - lByteCount % 4) / 4;
        lBytePosition = lByteCount % 4 * 8;
        lWordArray[lWordCount] = lWordArray[lWordCount] | 0x80 << lBytePosition;
        lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
        return lWordArray;
      }

      function md5_WordToHex(lValue) {
        var WordToHexValue = '',
            WordToHexValue_temp = '',
            lByte,
            lCount;
        for (lCount = 0; lCount <= 3; lCount++) {
          lByte = lValue >>> lCount * 8 & 255;

          WordToHexValue_temp = '0' + lByte.toString(16);
          WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
        }
        return WordToHexValue;
      }

      function md5_Utf8Encode(string) {
        string = string.replace(/\r\n/g, '\n');
        var utftext = '';
        for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
            utftext += String.fromCharCode(c);
          } else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode(c >> 6 | 192);
            utftext += String.fromCharCode(c & 63 | 128);
          } else {
            utftext += String.fromCharCode(c >> 12 | 224);
            utftext += String.fromCharCode(c >> 6 & 63 | 128);
            utftext += String.fromCharCode(c & 63 | 128);
          }
        }
        return utftext;
      }

      var x = Array();
      var k, AA, BB, CC, DD, a, b, c, d;

      var S11 = 7,
          S12 = 12,
          S13 = 17,
          S14 = 22;

      var S21 = 5,
          S22 = 9,
          S23 = 14,
          S24 = 20;

      var S31 = 4,
          S32 = 11,
          S33 = 16,
          S34 = 23;

      var S41 = 6,
          S42 = 10,
          S43 = 15,
          S44 = 21;
      string = md5_Utf8Encode(string);
      x = md5_ConvertToWordArray(string);
      a = 0x67452301;
      b = 0xEFCDAB89;
      c = 0x98BADCFE;
      d = 0x10325476;
      for (k = 0; k < x.length; k += 16) {
        AA = a;
        BB = b;
        CC = c;
        DD = d;
        a = md5_FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
        d = md5_FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
        c = md5_FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
        b = md5_FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
        a = md5_FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
        d = md5_FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
        c = md5_FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
        b = md5_FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
        a = md5_FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
        d = md5_FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
        c = md5_FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
        b = md5_FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
        a = md5_FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
        d = md5_FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
        c = md5_FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
        b = md5_FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
        a = md5_GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
        d = md5_GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
        c = md5_GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
        b = md5_GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
        a = md5_GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
        d = md5_GG(d, a, b, c, x[k + 10], S22, 0x2441453);
        c = md5_GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
        b = md5_GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
        a = md5_GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
        d = md5_GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
        c = md5_GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
        b = md5_GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
        a = md5_GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
        d = md5_GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
        c = md5_GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
        b = md5_GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
        a = md5_HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
        d = md5_HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
        c = md5_HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
        b = md5_HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
        a = md5_HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
        d = md5_HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
        c = md5_HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
        b = md5_HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
        a = md5_HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
        d = md5_HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
        c = md5_HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
        b = md5_HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
        a = md5_HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
        d = md5_HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
        c = md5_HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
        b = md5_HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
        a = md5_II(a, b, c, d, x[k + 0], S41, 0xF4292244);
        d = md5_II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
        c = md5_II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
        b = md5_II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
        a = md5_II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
        d = md5_II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
        c = md5_II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
        b = md5_II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
        a = md5_II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
        d = md5_II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
        c = md5_II(c, d, a, b, x[k + 6], S43, 0xA3014314);
        b = md5_II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
        a = md5_II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
        d = md5_II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
        c = md5_II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
        b = md5_II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
        a = md5_AddUnsigned(a, AA);
        b = md5_AddUnsigned(b, BB);
        c = md5_AddUnsigned(c, CC);
        d = md5_AddUnsigned(d, DD);
      }
      return (md5_WordToHex(a) + md5_WordToHex(b) + md5_WordToHex(c) + md5_WordToHex(d)).toLowerCase();
    }
  },
  getHtmlParam: function getHtmlParam() {
    var htmlParam = window.location.href.match(/\/([^/]+_{1}[^/]+)(\.html)/);
    if (htmlParam && htmlParam[1].indexOf('_') > -1) {
      var p = htmlParam[1].split('_');
      return {
        aid: p[0],
        sid: p[1]
      };
    } else {
      return '';
    }
  },
  browser: function browser() {
    var $agent = window.navigator.userAgent;
    return {
      mobile: $agent.indexOf('Android') > -1 || $agent.indexOf('Linux') > -1 || $agent.indexOf('iPhone') > -1 || /(Mobile)/gi.test($agent),
      ios: !!$agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      android: $agent.indexOf('Android') > -1 || $agent.indexOf('Linux') > -1,
      iPhone: $agent.indexOf('iPhone') > -1 || $agent.indexOf('Mac') > -1,
      iPad: $agent.indexOf('iPad') > -1,
      myApp: $agent.indexOf('xkyApp') > -1,
      isWX: $agent.indexOf('MicroMessenger') > -1 };
  },
  timeComparison: function timeComparison(time, exp) {
    if (!time || !exp) return;
    var _curTime = new Date().getTime();
    exp = exp || 0;
    time = time || _curTime;

    time = /T/g.test(time) ? new Date(new Date(time).toString()).getTime() : new Date(time.replace(/\-/g, '/')).getTime();
    if (time + exp * 1000 * 0.9 > _curTime) {
      return true;
    } else {
      return false;
    }
  },
  clientWidth: screen.width || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
  clientHeight: screen.height || window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
  videoPlayOne: function videoPlayOne(n) {
    try {
      var videoPlayOnes = document.getElementsByTagName('video');
      for (var i = videoPlayOnes.length - 1; i >= 0; i--) {
        videoPlayOnes[i].curIndex = i;
        videoPlayOnes[i].addEventListener('play', function () {
          for (var j = videoPlayOnes.length - 1; j >= 0; j--) {
            if (j != this.curIndex) videoPlayOnes[j].pause();
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  },
  evokeAppInit: function evokeAppInit(sid, topicID, discussID, topicDetailType, curId) {
    try {
      var param = {
        ti: document.title || '',
        aid: discussID || topicID,
        ty: discussID ? '105' : '104',
        id: discussID || topicID,
        sid: sid
      };
      if (!discussID) {
        param.topicDetailType = topicDetailType;
        param.cid = curId || '';
      }
      console.table(param);
      if (typeof gUserConfig !== 'undefined') {
        console.log('typeof gUserConfig !== \'undefined\'');
        setTimeout(function () {
          typeof evokeApp !== 'undefined' && typeof evokeApp.init === 'function' && evokeApp.init(param);
        }, 200);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajaxSetup({
          cache: true
        });
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.getScript('https://oss.newaircloud.com/global/user/' + sid + '/mobile/global.js').then(function (script, textStatus) {
          if (typeof gUserConfig !== 'undefined') {
            console.log('有没 list', typeof evokeApp !== 'undefined' && (typeof evokeApp === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(evokeApp)));

            setTimeout(function () {
              typeof evokeApp !== 'undefined' && typeof evokeApp.init === 'function' && evokeApp.init(param);
            }, 200);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  },
  wxLaunchHtml: function wxLaunchHtml(height, appid, data) {
    return '<span class="wx-launch-app-btn-outer">\n              <wx-open-launch-app class="wx-launch-app-btn" ' + (appid && 'appid=' + appid || '') + ' ' + (data && 'extinfo=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) || '') + ' >\n                <script type="text/wxtag-template">\n                    <style>\n                        .btn {\n                            height: ' + (height || '100%') + ';\n                            width: 100%;\n                            display: inline-block;\n                        }\n                    </style>\n                    <button class="btn"> App\u5185\u67E5\u770B </button>\n                </script>\n              </wx-open-launch-app>\n            </span>';
  },
  wxLaunchChange: function wxLaunchChange(container, fun, n, m, height, data, successFun) {
    try {
      fun = fun || function () {};
      var _shareData = data;
      try {
        if (/(apiconfigtest\.newaircloud\.com)|(http:\/\/127\.0\.0\.1)/.test(window.location.href)) {
          console.log(_openWxLaunch, _wxOpenAppID, container);
          console.log('wxLanuchChange0', typeof fun === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(fun));
        }
      } catch (e) {
        console.log(e);
      }

      if (window.navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/) && typeof _openWxLaunch !== 'undefined' && _openWxLaunch && typeof _wxOpenAppID !== 'undefined' && _wxOpenAppID && typeof _shareData !== 'undefined' && _shareData && !n) {
        console.log('wxLanuchChange1');
        try {
          if (m == 1) {
            var _p = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn-parent').html();
            console.log('_p', _p, container);

            _p && __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn-parent').html(_p + this.wxLaunchHtml(height || '32px', _wxOpenAppID, _shareData)).off('click').removeAttr('@click');
          }
        } catch (e) {
          console.log(e);
        }

        try {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn').attr({
            appid: _wxOpenAppID,

            extinfo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_shareData)
          }).on('error', fun);
          if (typeof successFun === 'function') {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn').on('launch', successFun);
          }
        } catch (e) {
          console.log(e);
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn-outer').remove();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn-parent').click(fun);
        }
      } else {
        console.log('wxLanuchChange11');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn-outer').remove();
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn-parent').click(fun);
      }
    } catch (e) {
      console.log(e);
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn-outer').remove();
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).find('.wx-launch-app-btn-parent').click(fun);
    }
  },
  articleJumpUrl: function articleJumpUrl(sid, articleType, articleID, columnID, linkID, curCid) {
    columnID = columnID || 0;
    linkID = linkID || 0;

    var articleUrl = '';

    if (articleType == 0) {
      articleUrl = '/detailArticle/' + articleID + '_' + columnID + '_' + sid + '.html';
    } else if (articleType == 1) {
      articleUrl = '/detailImage/' + articleID + '_' + columnID + '_' + sid + '.html';
    } else if (articleType == 2) {
      articleUrl = '/detailArticle/' + articleID + '_' + columnID + '_' + sid + '.html';
    } else if (articleType == 3) {
      articleUrl = '/special_detail?newsid=' + articleID + '_' + sid;
    } else if (articleType == 4) {
      articleUrl = '/link_detail?newsid=' + articleID + '_' + sid;
    } else if (articleType == 5) {
      articleUrl = '/news_detail?newsid=' + articleID + '_' + sid;
    } else if (articleType == 6) {
      articleUrl = '/live_detail?newsid=' + articleID + '_' + sid;
    } else if (articleType == 7) {
      articleUrl = '/news_detail?newsid=' + articleID + '_' + sid;
    } else if (articleType == 8) {
      articleUrl = '/adv_detail?newsid=' + articleID + '_' + sid;
    } else if (articleType == 20) {
      articleUrl = '/activeInfo/' + linkID + '_' + sid + '.html';
    } else if (articleType == 21) {
      articleUrl = '/detailsvd/' + articleID + '_' + columnID + '_' + sid + '.html';
    } else if (articleType == 22) {
      articleUrl = '/audioInfo/' + articleID + '_' + columnID + '_' + 1 + '_' + sid + '.html';
    } else if (articleType == 25) {
      articleUrl = '/news_detail?newsid=' + articleID + '_' + sid;
    } else if (articleType == 104) {
      articleUrl = '/topicColumn/' + sid + '/' + articleID;
    } else if (articleType == 'column') {
      articleUrl = '/column_view?cid=' + columnID + '&sid=' + sid;
    } else {
      articleUrl = '/news_detail?newsid=' + articleID + '_' + sid;
    }
    return articleUrl;
  }
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__url__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);







var _this = this;






var imageSize = {
  'lg': '?x-oss-process=image/resize,m_lfit,w_720,limit_0/auto-orient,1',
  'md': '?x-oss-process=image/resize,m_lfit,w_471,limit_0/auto-orient,1',
  'sm': '?x-oss-process=image/resize,m_lfit,w_160,limit_0/auto-orient,1',
  'o': '?x-oss-process=image/auto-orient,1'
};

var _getImageWidthAndHeight = function _getImageWidthAndHeight(imgUrl) {
  imgUrl = imgUrl || '';
  if (imgUrl.indexOf('newaircloud') > 0) {
    var _getImgInfo = imgUrl.indexOf('@!') > -1 ? imgUrl.split('@!')[0] : imgUrl.indexOf('?') > -1 ? imgUrl.split('?')[0] : imgUrl;
    var _o = {};
    try {
      __WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({
        url: _getImgInfo.replace('http://', 'https://') + '?x-oss-process=image/info',
        async: false,
        type: 'GET',
        dataType: 'json',
        success: function success(result, status, xhr) {
          _o.w = result.ImageWidth.value ? result.ImageWidth.value : '';

          _o.h = result.ImageHeight.value ? result.ImageHeight.value : '';

          _o.r = _o.w / _o.h;
        },
        error: function error(xhr, status, _error) {
          console.log('_getImageWidthAndHeight -- error : ', xhr, status, _error);
        }
      });
    } catch (e) {}
    return _o;
  }
};

var handleImgScaleUrl = function handleImgScaleUrl(item, imgScale, other) {
  item = item || '';

  item == 'undefined' ? item = '' : '';

  if (!item || item.indexOf('newaircloud') === -1 || /(\.gif)/gi.test(item) && imgScale == 'o') return item;
  item = item.replace(/http:\/\/img\.newaircloud\.com/gi, 'https://oss.newaircloud.com');

  imgScale = other && imgScale || imgScale && imageSize[imgScale] || imageSize.md;
  item = item.indexOf('@!') > -1 ? item.replace('http://', 'https://') : item.indexOf('x-oss-process') > -1 ? item.replace('http://', 'https://') : item.replace('http://', 'https://') + imgScale;
  return item;
};

var parseImageStyle = function parseImageStyle(items, config) {
  if (!items) return '';
  var imgMore = '';
  var imgOne = '';
  var imgOriginal = '';
  if (config && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(config).length > 0) {
    imgMore = config.img_param_global ? '?' + (config.img_param_global || '') + (config.img_param_format || '') + (config.img_param_size_more || '') + (config.img_param_waterMark || '') : '';
    imgOne = config.img_param_global ? '?' + (config.img_param_global || '') + (config.img_param_format || '') + (config.img_param_size_one || '') + (config.img_param_waterMark || '') : '';
    imgOriginal = config.img_param_global ? '?' + (config.img_param_global || '') + (config.img_param_format || '') + (config.img_param_waterMark || '') : '';
  }
  var curList = [];

  var _w = 250,
      _y = 180,
      _x = 1,
      _l = 6,
      _clientWidth = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].clientWidth || 0,
      _clientHeight = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].clientHeight || 0;
  var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
  if (deviceWidth >= 750) {
    deviceWidth = 750;
  }
  if (deviceWidth <= 320) {
    deviceWidth = 320;
  }
  if (!__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].browser().mobile) {
    _clientWidth = 414;
    deviceWidth = 414;
  }
  deviceWidth = deviceWidth / 7.5;
  for (var i = 0; i < items.length; i++) {
    var cur = items[i];
    cur._picsLength = 0;
    cur._videosLength = 0;
    cur._clientWidth = _clientWidth || 0;
    cur._clientHeight = _clientHeight || 0;
    if (cur && cur.attUrls && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(cur.attUrls).length > 0) {
      var curAtt = cur.attUrls;
      if (curAtt.pics && curAtt.pics.length > 0) {

        cur._picsLength = curAtt.pics.length;
        var _curWidthHeight = _getImageWidthAndHeight(curAtt.pics[0] && curAtt.pics[0].url);
        _x = _curWidthHeight.r;
        if (cur._picsLength > 1) {
          _w = _clientWidth - (0.66 * deviceWidth + 0.3 * deviceWidth + 0.3 * deviceWidth);
          _y = 100;
          _x = 1;
          _l = 0.12 * deviceWidth;
          _y = (_w - 2 * _l) / 3;
          cur._picsWidth = (_w - 2 * _l) / 3 + 'px';
          cur._picsHeight = (_w - 2 * _l) / 3 + 'px';
        } else {
          _w = 250;
          _y = 180;
          _l = 6;
          if (_x > 3) {
            cur._picsWidth = _w / 50 + 'rem';
            cur._picsHeight = (_w - 2 * _l) / 3 / 50 + 'rem';
          } else if (_x >= 1 && _x <= 3) {
            cur._picsWidth = _y / 50 + 'rem';
            cur._picsHeight = _y / _x / 50 + 'rem';
          } else if (_x >= 1 / 3 && _x <= 1) {
            cur._picsWidth = _y * _x / 50 + 'rem';
            cur._picsHeight = _y / 50 + 'rem';
          } else if (_x < 1 / 3) {
            cur._picsWidth = _y / 3 / 50 + 'rem';
            cur._picsHeight = _y / 50 + 'rem';
          }
        }

        for (var n = 0; n < curAtt.pics.length; n++) {
          curAtt.pics[n] && curAtt.pics[n].url ? (curAtt.pics[n].urlOriginal = handleImgScaleUrl(curAtt.pics[n].url, imgOriginal, 1)) && (curAtt.pics[n].url = handleImgScaleUrl(curAtt.pics[n].url, curAtt.pics.length === 1 && imgOne || imgMore, 1)) : '';
        }
      }

      if (curAtt.videos && curAtt.videos.length > 0) {
        cur._videosLength = curAtt.videos.length;
        cur._videosHeight = (cur._clientWidth / 50 - 0.6 - 0.66) / 1.77777778 && (cur._clientWidth / 50 - 0.6 - 0.66) / 1.77777778 + 'rem' || 'auto';
      }

      if (curAtt.videoPics && curAtt.videoPics.length > 0) {
        curAtt.videoPics && curAtt.videoPics[0] && curAtt.videoPics[0].url ? curAtt.videoPics[0].url = handleImgScaleUrl(curAtt.videoPics[0].url) : '';
      }
    }

    if (cur.faceUrl && cur.faceUrl.length > 0) {
      cur.faceUrl = handleImgScaleUrl(cur.faceUrl, 'sm');
    }

    if (cur && cur.discussID && (localStorage.getItem('topicDiscussPraise') || '').indexOf(cur.discussID) > -1) {
      cur.curClass = 'news_comment_praise_img_active';
    } else {
      cur.curClass = 'news_comment_praise_img_' + cur.discussID;
    }
    curList.push(cur);
  }
  return curList || '';
};

var requestHeader = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(data, n, str) {
    var _sid, _a, _v, _d, _s, _t, _ti, _n, _si, _o;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _sid = data.sid;
            _a = '';

            if (n) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return getToken(data);

          case 5:
            _a = _context.sent;

          case 6:
            str = str || '';
            _v = '1.0', _d = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].getUrlParam('deviceID') ? __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].getUrlParam('deviceID') : __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].SHA_UUID_MD.UUID(), _s = 1, _t = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].SHA_UUID_MD.MD5(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].SHA_UUID_MD.MD5(_sid)), _ti = new Date().myUTCFormat(), _n = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].SHA_UUID_MD.UUID();
            _si = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].SHA_UUID_MD.HEX_SHA1(_t + _n + _ti + _v + str + _d + _s + _a);
            _o = {};

            _o.data = {
              sid: _sid,
              deviceID: _d,
              source: _s,
              sign: _si
            };

            if (data || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data).length > 0) {
              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_o.data, data);
            }
            _o.headers = {
              timestamp: _ti,
              tenant: _t,
              version: _v,
              nonce: _n
            };
            if (_a) {
              _o.headers.authtoken = _a;
            }
            return _context.abrupt('return', _o);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function requestHeader(_x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var getToken = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(d) {
    var _authtoken, _getToken, localToData;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _authtoken = '';

            _getToken = function () {
              var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(d, callback) {
                var _h;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _getToken.retry = _getToken.retry || 0;

                        if (!(_getToken.retry > 3)) {
                          _context2.next = 4;
                          break;
                        }

                        alert('网络有些问题，请稍后再试!');
                        return _context2.abrupt('return');

                      case 4:
                        _context2.next = 6;
                        return requestHeader(d, 1);

                      case 6:
                        _h = _context2.sent;

                        _getToken.retry++;
                        _context2.next = 10;
                        return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._TOKEN, _h.data, {
                          headers: _h.headers
                        }).then(function (_ref4) {
                          var data = _ref4.data;

                          if (typeof data !== 'undefined' && data.success == 1 && data.authtoken && data.authtoken.length > 0) {
                            localStorage.setItem('localToData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                              timestamp: _h.headers.timestamp,
                              authtoken: data.authtoken,
                              expires_in: data.expires_in,
                              sid: d.sid,
                              domain: window.location.origin
                            }));
                            _getToken.retry = 0;
                            typeof callback === 'function' && callback(data.authtoken);
                          } else {
                            _getToken.retry = 3;
                            if (data && /请校正系统时间/.test(data.msg)) {
                              alert(data.msg);
                            } else {
                              console.log(data.msg);
                            }
                          }
                        }).catch(function (err) {
                          _getToken.retry = 0;
                          console.log('_getToken-err', err);
                        });

                      case 10:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this);
              }));

              return function _getToken(_x6, _x7) {
                return _ref3.apply(this, arguments);
              };
            }();

            localToData = localStorage.getItem('localToData');

            if (!(localToData != null)) {
              _context3.next = 13;
              break;
            }

            localToData = JSON.parse(localStorage.getItem('localToData'));

            if (!(localToData && localToData.timestamp && __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].timeComparison(localToData.timestamp, localToData.expires_in) && localToData.domain == window.location.origin && localToData.sid == d.sid)) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt('return', localToData.authtoken && localToData.authtoken.length > 0 ? localToData.authtoken : '');

          case 9:
            _context3.next = 11;
            return _getToken(d, function (res) {
              _authtoken = res;
            });

          case 11:
            _context3.next = 15;
            break;

          case 13:
            _context3.next = 15;
            return _getToken(d, function (res) {
              _authtoken = res;
            });

          case 15:
            return _context3.abrupt('return', _authtoken || '');

          case 16:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function getToken(_x5) {
    return _ref2.apply(this, arguments);
  };
}();

var getAxios = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(url, param, type, str) {
    var _p;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            getAxios[url] = getAxios[url] || 0;

            if (!(getAxios[url] > 2)) {
              _context4.next = 4;
              break;
            }

            getAxios[url] = 0;
            return _context4.abrupt('return', '');

          case 4:
            _context4.next = 6;
            return requestHeader(param, 0, str);

          case 6:
            _p = _context4.sent;

            getAxios[url]++;
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var _submitData = {
                url: url,
                headers: _p.headers
              };
              if (type) {
                _submitData.method = 'POST';
                _submitData.data = _p.data;
              } else {
                _submitData.params = _p.data;
              }
              __WEBPACK_IMPORTED_MODULE_6_axios___default()(_submitData).then(function (res) {
                if (res && res.data) {
                  if (res.data.success || typeof res.data.success === 'undefined') {
                    getAxios[url] = 0;
                    return resolve(res);
                  } else if (!res.data.success && /(无效的签名)|(appToken无效)/.test(res.data.msg)) {
                    if (getAxios.retry > 2) {
                      getAxios[url] = 0;
                      return resolve(res);
                    } else {
                      localStorage.removeItem('localToData');
                      getAxios(url, param, type, str);
                    }
                  }
                }
              }).catch(function (err) {
                console.log('getAxios-err', err);
                getAxios[url] = 0;
                return reject(err);
              });
            }));

          case 9:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function getAxios(_x8, _x9, _x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();

var getTopicInfo = function getTopicInfo(param) {
  return getAxios(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._GETTOPICINFO, param, '', '' + param.uid + param.topicID);
};

var getConfig = function getConfig(param) {
  return getAxios(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._GETCONFIG, param);
};

var clickPraise = function clickPraise(param, n) {
  var str = '';
  if (n) {
    str = param.uid + '' + param.discussID;
  } else {
    str = param.id + '' + param.type + '' + param.eventType;
  }
  return getAxios(n && __WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._DISCUSSPRAISE || __WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._SUBEVENT, param, 1, str);
};

var getTopicDiscussContent = function getTopicDiscussContent(param) {
  return getAxios(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._GETTOPICDISCUSSCONTENT, param, '', '' + param.discussID);
};

var getHotComments = function getHotComments(param) {
  var str = '';
  str = param.userID + '' + param.rootID + '' + param.sourceType + param.lastFileID + '' + param.rowNumber;
  return getAxios(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._GETHOTCOMMENTS, param, 0, str);
};

var getComments = function getComments(param) {
  var str = '';
  str = param.userID + '' + param.rootID + '' + param.sourceType + param.lastFileID + '' + param.rowNumber;
  return getAxios(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._GETCOMMENTS, param, 0, str);
};

var getDiscussList = function getDiscussList(param) {
  return getAxios(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._GETDISCUSSLIST, param, 0, '' + param.pageNum + '' + param.topicID);
};

var submitComment = function submitComment(param) {
  var str = param.userID + encodeURIComponent(param.userName) + '' + param.rootID + param.parentID + param.sourceType + encodeURIComponent(param.topic) + param.articleType;
  return getAxios(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._SUBMITCOMMENT, param, 1, str);
};

var getTopicAdv = function getTopicAdv(param) {
  return getAxios(__WEBPACK_IMPORTED_MODULE_8__url__["a" /* default */]._GETTOPICADV, param, 0, '' + param.cid + param.uid);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  parseImageStyle: parseImageStyle,
  handleImgScaleUrl: handleImgScaleUrl,
  clickPraise: clickPraise,
  getConfig: getConfig,
  getTopicDiscussContent: getTopicDiscussContent,
  getHotComments: getHotComments,
  getComments: getComments,
  getDiscussList: getDiscussList,
  getTopicInfo: getTopicInfo,
  submitComment: submitComment,
  getTopicAdv: getTopicAdv
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(327),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk__);



var wxShare = function wxShare(params) {
  var UrlHost = window.location.host;
  if (UrlHost && UrlHost.indexOf('newaircloud.com') >= 0 && window.location.protocol === 'https:' || window.location.protocol === 'https:') {
    UrlHost = 'https://' + window.location.host;
  } else {
    UrlHost = 'http://' + window.location.host;
  }

  var _img = gUserConfigDir + '/img/icon.png';

  params.imgUrl = params.imgUrl || _img;
  var shareData = {
    title: params.title,
    desc: params.desc,
    link: window.location.href,
    imgUrl: params.imgUrl };
  var _shareUrl = window.location.href;
  var _shareTimestampKey = 'xkyTimestamp';
  try {
    var url = new URL(window.location.href);
    var _shareTimestamp = url.searchParams.get(_shareTimestampKey);
    if (_shareTimestamp) {
      var _shareTimestampReg = new RegExp('[\?\&]' + _shareTimestampKey + '=' + _shareTimestamp, 'gi');
      _shareUrl = _shareUrl.replace(_shareTimestampReg, '');
    }
    _shareUrl += (/\?/.test(_shareUrl) ? '&' : '?') + _shareTimestampKey + '=' + new Date().getTime();
  } catch (e) {
    console.log(e);
  }
  shareData.link = _shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(UrlHost + '/api/getWXJSApiConfig?sid=' + params.sid + '&url=' + encodeURIComponent(window.location.href)).then(function (res) {
    try {
      if (res && res.data && res.data.appId) {
        try {
          var data = res.data;

          if (data && data.secondShare && data.secondShare.secondShareSwitch == 1) {
            if (data.secondShare.showAbstractType != 2) {
              shareData.desc = data.secondShare.summary || '';
            } else {
              shareData.desc = shareData.desc || data.secondShare.summary || '';
            }
            if (data.secondShare.titlePrefix) {
              shareData.title = data.secondShare.titlePrefix + shareData.title;
            }
            if (data.secondShare.titleSuffix) {
              shareData.title = shareData.title + data.secondShare.titleSuffix;
            }
            if (data.secondShare.thumbnail && data.secondShare.thumbnail.length > 0) {
              shareData.imgUrl = data.secondShare.thumbnail;
            }
          } else {
            if (typeof gUserConfig !== 'undefined') {
              if (gUserConfig.appName) {
                shareData.title = gUserConfig.wxShowAppNameSite == 1 ? shareData.title + gUserConfig.appName : gUserConfig.appName + shareData.title;
              }

              if (gUserConfig.wxShowDes) {
                shareData.desc = gUserConfig.wxShowDes || '';
              }

              if (gUserConfig.wxShowImg == 1 && _img) {
                shareData.imgUrl = _img;
              }
            }
          }
        } catch (e) {
          console.log(e);
        }
        var _wxData = {
          appId: res.data.appId,
          nonceStr: res.data.noncestr,
          timestamp: res.data.timestamp,
          signature: res.data.signature,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone']
        };

        if (typeof gUserConfig !== 'undefined' && gUserConfig.openWxLaunch == 1 && navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/)) {
          _wxData.openTagList = ['wx-open-launch-app'];
        }
        __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.config(_wxData);
        __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.ready(function () {
          __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareTimeline(shareData);
          __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareAppMessage(shareData);
          __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareQQ(shareData);
          __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareQZone(shareData);
        });
      } else {
        document.querySelector('meta[itemprop=\'name\']').setAttribute('content', shareData.title);
        document.querySelector('meta[itemprop=\'description\']').setAttribute('content', shareData.desc);
        document.querySelector('meta[itemprop=\'image\']').setAttribute('content', shareData.imgUrl);
      }
      if (/(apiconfigtest\.newaircloud\.com)|(http:\/\/127\.0\.0\.1)/.test(window.location.href)) {
        console.table(shareData);
      }
    } catch (e) {
      console.log(e);
    }
  }).catch(function (err) {
    console.log(err);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({ wxShare: wxShare });

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(332),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(329),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bcec4738",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(312),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-111f9b18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(315),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34113fa2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(322),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44b0c872",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(311),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-073f1b00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_topicColumn__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_topicColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__page_topicColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_topicColumnDetail__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_topicColumnDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_topicColumnDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_test__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__page_test__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var scrollY = '';

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  var position = {};
  if (to.name === 'topicColumn') {
    position.x = 0;
    position.y = scrollY;
    return position;
  } else {
    if (to.matched.some(function (m) {
      return m.meta.scrollToTop;
    })) {
      position.x = 0;
      position.y = 0;
    }

    return position;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: '/topicColumn/:sid/:topicID',
    name: 'topicColumn',
    component: __WEBPACK_IMPORTED_MODULE_3__page_topicColumn___default.a
  }, {
    path: '/topicColumn/:sid/:topicID/:discussID',

    name: 'topicColumnDetail',
    component: __WEBPACK_IMPORTED_MODULE_4__page_topicColumnDetail___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      scrollY = window.scrollY;
      next();
    },

    meta: { scrollToTop: true }
  }, {
    path: '/test',
    name: 'test',
    component: __WEBPACK_IMPORTED_MODULE_5__page_test___default.a
  }]
}));

/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(328),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(133);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_swiper_swiper__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_swiper_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_swiper_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tool_submit__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tool_utils__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      topicInfo: {},
      topicID: '',
      discussID: '',
      sid: '',
      uid: '',
      bg: '',
      govImage: '',
      attention: true,
      busy: true,
      page: -1,
      pageSize: 10,
      themeColor: '#13b7f6',
      appName: '',
      downAppHref: '',
      pics: [],
      initIndex: 0,
      isShowSwiper: 0
    };
  },
  beforeMount: function beforeMount() {},
  created: function created() {
    this.topicID = this.$route.params.topicID;
    this.discussID = this.$route.params.discussID;
    this.sid = this.$route.params.sid;
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__tool_submit__["a" /* default */].getTopicInfo({ topicID: _this.topicID, sid: _this.sid }).then(function (response) {
      _this.topicInfo = response.data;
      document.title = _this.topicInfo.title;
      if (!_this.isEmptyObject(_this.topicInfo.config)) {
        _this.govImage = __WEBPACK_IMPORTED_MODULE_2__tool_submit__["a" /* default */].handleImgScaleUrl(_this.topicInfo.config.govImage, 'sm');
      }
      try {
        window.sessionStorage.setItem('configDescription', _this.topicInfo.config && _this.topicInfo.config.description || '');
      } catch (e) {
        console.log(e);
      }
    }).catch(function (error) {
      console.log(error);
    });

    _this.themeColor = _themeColor;

    _this.appName = _appName;
    this.fnResize();
    window.onresize = function () {
      if (__WEBPACK_IMPORTED_MODULE_3__tool_utils__["a" /* default */].browser().mobile) {
        _this.fnResize();
      }
    };
  },
  mounted: function mounted() {
    var $agent = window.navigator.userAgent;
    if (!($agent.indexOf('Android') > -1 || $agent.indexOf('Linux') > -1 || $agent.indexOf('iPhone') > -1) || /(Mobile)/gi.test($agent)) {
      try {
        document.getElementsByTagName('body')[0].style.maxWidth = '7.5rem';
        document.getElementsByTagName('body')[0].style.margin = 'auto';
      } catch (e) {
        console.log(e);
      }
    }
  },

  methods: {
    isEmptyObject: function isEmptyObject(obj) {
      for (var key in obj) {
        return false;
      }
      return true;
    },

    fnResize: function fnResize() {
      var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
      if (deviceWidth >= 750) {
        deviceWidth = 750;
      }
      if (deviceWidth <= 320) {
        deviceWidth = 320;
      }

      if (!__WEBPACK_IMPORTED_MODULE_3__tool_utils__["a" /* default */].browser().mobile && __WEBPACK_IMPORTED_MODULE_3__tool_utils__["a" /* default */].getUrlParam('mobile') != 1 && !/(pc_body_class)/.test(document.body.className)) {
        try {
          document.body.className += ' pc_body_class';
          deviceWidth = 414;
        } catch (e) {
          console.log(e);
        }
      }

      document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px';
    },
    downApp: function downApp(e) {
      if (typeof evokeApp !== 'undefined' && typeof evokeApp.jumpApp === 'function') {
        evokeApp.jumpApp();
      } else {
        try {
          var downAppHref = gUserConfig.downAppUrl;

          var openAppScheme = gUserConfig.openAppSchemes;

          window.location.href = openAppScheme;

          setTimeout(function () {
            window.location.href = downAppHref;
          }, 500);
        } catch (e) {
          window.location.href = gUserConfig.downAppUrl;
          console.log(e);
        }
      }
    },
    closeImg: function closeImg() {
      this.isShowSwiper = 0;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({ overflow: 'initial' });
    },

    showSwiper: function showSwiper(list, index) {
      if (!list) {
        this.closeImg();
        return;
      }

      this.pics = list;
      this.isShowSwiper = 1;
      this.initIndex = index;
    }
  },
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1__components_swiper_swiper___default.a
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);



var _userAgent = window.navigator.userAgent;
var _agent = _userAgent.indexOf('xkyApp') === -1;



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['sid', 'themeColor'],
  data: function data() {
    return {
      iconUrl: '',
      downloadBarBgColor: '',
      bannerShow: false,
      iconImg: 'https://' + this.$route.params.sid + 'oss.newaircloud.com/global/user/' + this.$route.params.sid + '/mobile/img/base_bottom_logo.png',
      downAppHref: '',
      openAppScheme: ''
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var _self = this;
    _self.downAppHref = sessionStorage.getItem('downAppHref');

    if (_agent) {
      if (__WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].getUrlParam('hideBanner') == 1 || window.gUserConfig.isMobileShowFixBottom != 1) {
        this.bannerShow = false;
      } else {
        window.gUserConfig.downloadBarPosition = window.gUserConfig.downloadBarPosition || 0;

        if (window.gUserConfig.downloadBarPosition == 0) {
          this.bannerShow = true;
          document.querySelector('body').style['padding-bottom'] = '55px';
        } else if (window.gUserConfig.downloadBarPosition == 1) {
          document.querySelector('body').style['padding-bottom'] = '0px';
          if (window.gUserConfig.bgColor) {
            this.downloadBarBgColor = window.gUserConfig.bgColor;
          }
          this.bannerShow = false;
        } else {
          document.querySelector('body').style['padding-bottom'] = '55px';

          if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).scrollTop() > 50) {
            this.bannerShow = true;
          } else {
            this.bannerShow = false;
          }
          window.addEventListener('scroll', function () {
            if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).scrollTop() > 50) {
              _this.bannerShow = true;
            } else {
              _this.bannerShow = false;
            }
          });
        }
      }
    } else {
      this.bannerShow = false;
    }
  },

  methods: {
    closeShow: function closeShow() {
      this.bannerShow = false;
    },
    openAppOrHref: function openAppOrHref() {
      this.$emit('topicToApp');
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var _userAgent = window.navigator.userAgent;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommentBox',
  props: ['topicInfo', 'sid', 'discussID'],
  data: function data() {
    return {
      showSubmit: 0
    };
  },

  methods: {
    submitComment: function submitComment() {
      window.location.href = 'writetopiccomment:///?discussID=' + this.discussID + '&title=' + encodeURIComponent(this.topicInfo.title);
    }
  },
  mounted: function mounted() {
    try {
      if (_userAgent.indexOf('xkyApp') > -1) {
        try {
          var str = this.topicInfo.endTime;
          str = str && (str + '').replace(/-/g, '/');

          this.showSubmit = (this.sid == 'cxjrb' || this.sid == 'xkycs' || this.sid == 'trrb') && new Date(str).getTime() - new Date().getTime() > 0 || 0;
        } catch (e) {
          console.log(e);
        }
      }
    } catch (e) {
      console.log(e);
    }
  },

  watch: {
    topicInfo: function topicInfo(newValue, oldValue) {
      try {
        if (_userAgent.indexOf('xkyApp') > -1) {
          try {
            var str = this.topicInfo.endTime;
            str = str && (str + '').replace(/-/g, '/');

            this.showSubmit = (this.sid == 'cxjrb' || this.sid == 'xkycs' || this.sid == 'trrb') && new Date(str).getTime() - new Date().getTime() > 0 || 0;
          } catch (e) {
            console.log(e);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tool_utils__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Popover',
  props: ['appName', 'istopiclist', 'topicInfo'],
  data: function data() {
    return {
      popoverContent: this.istopiclist === 1 ? '\u8BF7\u524D\u5F80' + this.appName + 'APP\u8FDB\u884C\u8BC4\u8BBA' : '\u524D\u5F80' + this.appName + 'APP\u67E5\u770B\u5B8C\u6574\u8BDD\u9898\uFF0C\u4F53\u9A8C\u66F4\u52A0'
    };
  },

  watch: {
    appName: function appName(newValue, oldValue) {
      this.appName = newValue;
      this.popoverContent = this.istopiclist === 1 ? '\u8BF7\u524D\u5F80' + this.appName + 'APP\u8FDB\u884C\u8BC4\u8BBA' : '\u524D\u5F80' + this.appName + 'APP\u67E5\u770B\u5B8C\u6574\u8BDD\u9898\uFF0C\u4F53\u9A8C\u66F4\u52A0';
    }
  },
  mounted: function mounted() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({ overflow: 'hidden' });
    var _shareData = {
      ti: document.title || '',
      aid: _this.$route.params.discussID || _this.$route.params.topicID,
      ty: _this.$route.params.discussID ? '105' : '104',
      id: _this.$route.params.discussID || _this.$route.params.topicID,
      sid: _this.$route.params.sid
    };
    __WEBPACK_IMPORTED_MODULE_1__tool_utils__["a" /* default */].wxLaunchChange('.p-b-i-bottom', _this.clickEnsure, '', 1, '47px', _shareData, function () {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({ overflow: 'initial' });
        if (_this.istopiclist === 1) {
          _this.$emit('showPopover', 1);
        } else {
          _this.$emit('openTopic', 0);
        }
      }, 200);
    });
  },

  methods: {
    clickEnsure: function clickEnsure() {
      var _this = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({ overflow: 'initial' });
        if (_this.istopiclist === 1) {
          _this.$emit('showPopover', 1);
        } else {
          _this.$emit('openTopic', 0);
        }
      }, 200);
      this.$emit('openAppOrTopic');
      this.$emit('topicToApp');
    },
    clickCancel: function clickCancel() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({ overflow: 'initial' });
      var _this = this;
      if (_this.istopiclist === 1) {
        this.$emit('showPopover', 1);
      } else {
        _this.$router.push({
          name: 'topicColumn',
          param: {
            sid: this.$route.params.sid,
            topicID: this.$route.params.topicID,
            topicInfo: this.topicInfo
          }
        });
      }
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tool_submit__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commentOperation__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commentOperation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__commentOperation__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'commentContent',
  props: ['items', 'govImage'],
  data: function data() {
    return {
      discussID: '',
      sid: '',
      commentID: '',
      type: 1,
      eventType: 2,
      list: [],
      topicCommentPraise: localStorage.getItem('topicCommentPraise') || '',

      ipSwitch: _ipSwitch == 1 && 1 || 0
    };
  },
  created: function created() {
    var _this2 = this;

    this.sid = this.$route.params.sid;
    this.items.forEach(function (item, index) {
      if (item && item.commentID && _this2.topicCommentPraise.indexOf(item.commentID) > -1) {
        item.curClass = 'news_comment_praise_img_active';
      } else {
        item.curClass = 'news_comment_praise_img_' + item.commentID;
      }

      item.commentOfficial = (typeof gUserConfigDir !== 'undefined' && (gUserConfigDir + '').replace(/(\/global.*$)/, '') || 'https://oss.newaircloud.com') + '/global/app/v1/common/img/comment_official.png';
      item.faceUrl ? item.faceUrl = __WEBPACK_IMPORTED_MODULE_1__tool_submit__["a" /* default */].handleImgScaleUrl(item.faceUrl, 'sm') : '';
      _this2.list.push(item);
    });
  },

  methods: {
    clickPares: function clickPares(item) {
      if (!item) return;
      var _this = this;
      var data = {
        sid: _this.sid,
        id: item.commentID,
        type: 1,
        eventType: 2
      };
      __WEBPACK_IMPORTED_MODULE_1__tool_submit__["a" /* default */]._clickPraise(data).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.news_comment_praise_img_' + item.commentID).addClass('news_comment_praise_img_active');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.news_comment_praise_count_' + item.commentID).text(res.data.countPraise);
        if ((localStorage.getItem('topicCommentPraise') || '').indexOf(item.commentID) === -1) {
          localStorage.setItem('topicCommentPraise', (localStorage.getItem('topicCommentPraise') || '') + '_' + item.commentID);
        }
        item.countPraise = res.data.countPraise;
      }).catch(function (err) {
        console.log('clickPares-result-err', err);
      });
    },
    parseSpace: function parseSpace(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseSpace(t);
    }
  },
  filters: {
    parseDateTime: function parseDateTime(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseDateTime(t);
    },
    parseSpace: function parseSpace(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseSpace(t);
    },
    parseCount: function parseCount(t) {
      if (!t) return;
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseCount(t);
    }
  },
  components: {
    commentOperation: __WEBPACK_IMPORTED_MODULE_3__commentOperation___default.a
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_submit__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tool_utils__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'commentOperation',
  props: ['item', 'isDetail'],
  data: function data() {
    return {
      sid: this.$route.params.sid,
      showCommentBanner: 0
    };
  },

  methods: {
    clickPares: function clickPares(item, n) {
      if (!item) return;
      var id = n ? item.discussID : item.commentID;
      if ((localStorage.getItem('topicDiscussPraise') || '').indexOf(id) > -1 || (localStorage.getItem('topicCommentPraise') || '').indexOf(id) > -1) return;
      var _this = this;
      var data = {
        sid: _this.sid
      };

      if (n) {
        data.uid = 0;
        data.discussID = id;
      } else {
        data.type = 1;
        data.eventType = 2;
        data.id = id;
      }

      __WEBPACK_IMPORTED_MODULE_0__tool_submit__["a" /* default */].clickPraise(data, n).then(function (res) {
        if (res && res.data) {
          if (n) {
            if ((localStorage.getItem('topicDiscussPraise') || '').indexOf(id) === -1) {
              localStorage.setItem('topicDiscussPraise', (localStorage.getItem('topicDiscussPraise') || '') + '_' + id);
            }
            item.praiseCount = res.data.praiseCount;
            item.commentCount = res.data.commentCount;
            item.curClass = 'news_comment_praise_img_active';
            if (item.praiseCount > 0) {
              __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.news_comment_praise_count_discuss_' + id).text(res.data.praiseCount).show();
            }
            if (item.commentCount > 0) {
              __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.no_news_comment_praise_count_discuss_' + id).text(res.data.commentCount).show();
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.news_comment_praise_img_' + id).addClass('news_comment_praise_img_active');
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.news_comment_praise_count_' + id).text(res.data.countPraise);

            if ((localStorage.getItem('topicCommentPraise') || '').indexOf(id) === -1) {
              localStorage.setItem('topicCommentPraise', (localStorage.getItem('topicCommentPraise') || '') + '_' + id);
            }
            item.countPraise = res.data.countPraise;
            item.curClass = 'news_comment_praise_img_active';
          }
        }
      }).catch(function (err) {
        console.log('clickPares-result-err', err);
      });
    },
    clickShowPopover: function clickShowPopover() {
      this.$emit('detailShowPopover');
    },
    clickShowCommentBanner: function clickShowCommentBanner() {
      this.showCommentBanner = !this.showCommentBanner;
    }
  },
  filters: {
    parseCount: function parseCount(t) {
      if (!t) return;
      return __WEBPACK_IMPORTED_MODULE_2__tool_utils__["a" /* default */].parseCount(t);
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commentContent__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commentContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__commentContent__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['hotComments', 'govImage', 'themeColor'],
  mounted: function mounted() {},

  filters: {
    parseDateTime: function parseDateTime(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseDateTime(t);
    },
    parseSpace: function parseSpace(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseSpace(t);
    },
    parseCount1: function parseCount1(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseCount(t);
    }
  },
  components: {
    commentContent: __WEBPACK_IMPORTED_MODULE_1__commentContent___default.a
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commentContent__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commentContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__commentContent__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['lastComments', 'govImage'],
  mounted: function mounted() {},

  filters: {
    parseDateTime: function parseDateTime(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseDateTime(t);
    },
    parseSpace: function parseSpace(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseSpace(t);
    },
    parseCount: function parseCount(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseCount(t);
    }
  },
  components: {
    commentContent: __WEBPACK_IMPORTED_MODULE_1__commentContent___default.a
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    offset: {
      type: Number,
      default: 40
    },
    loadingText: {
      type: String,
      default: '加载中...'
    },
    enableInfinite: {
      type: Boolean,
      default: true
    },
    enableRefresh: {
      type: Boolean,
      default: true
    },
    onRefresh: {
      type: Function,
      default: undefined,
      required: false
    },
    onInfinite: {
      type: Function,
      default: undefined,
      require: false
    }
  },
  data: function data() {
    return {
      top: 0,
      state: 0,
      startY: 0,
      touching: false,
      infiniteLoading: false,
      clientHeight: (window.innerWidth || screen.width || document.documentElement.clientWidth || document.body.clientWidth) / 16 * 9 * 2 / 100
    };
  },

  methods: {
    touchStart: function touchStart(e) {
      var _t = window.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
      if (_t > 8) {
        return;
      }
      this.startY = e.targetTouches[0].pageY;
      this.startScroll = this.$el.scrollTop || 0;
      this.touching = true;
    },
    touchMove: function touchMove(e) {
      var _t = window.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
      if (_t > 8) {
        return;
      }
      if (!this.enableRefresh || this.$el.scrollTop > 0 || !this.touching) {
        return;
      }
      var diff = e.targetTouches[0].pageY - this.startY - this.startScroll;
      if (diff > 0) e.preventDefault();
      this.top = Math.pow(diff, 0.8) + (this.state === 2 ? this.offset : 0);

      if (this.state === 2) {
        return;
      }
      if (this.top >= this.offset - 500) {
        this.state = 1;
      } else {
        this.state = 0;
      }
    },
    touchEnd: function touchEnd(e) {
      var _t = window.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
      if (_t > 8) {
        return;
      }
      if (!this.enableRefresh) return;
      this.touching = false;
      if (this.state === 2) {
        this.state = 2;
        this.top = this.offset;
        return;
      }
      if (this.top >= this.offset) {
        this.refresh();
      } else {
        this.state = 0;
        this.top = 0;
      }
    },
    refresh: function refresh() {
      var _this2 = this;

      this.state = 2;
      this.top = this.offset;
      setTimeout(function () {
        _this2.onRefresh(_this2.refreshDone);
      }, 1000);
    },
    refreshDone: function refreshDone() {
      var _this3 = this;

      this.state = 3;
      setTimeout(function () {
        _this3.state = 0;
        _this3.top = 0;
        _this3.infiniteLoading = false;
        _this3.startY = 0;
        _this3.touching = false;
      }, 700);
    },
    infinite: function infinite() {
      this.infiniteLoading = true;
      this.onInfinite(this.infiniteDone);
      window.onceFlag = window.onceFlag || 0;
      var _this = this;
      if (window.onceFlag === 0) {
        window.onceFlag = 111;
        window.onscroll = function (e) {
          if (!_this.enableInfinite || _this.infiniteLoading) {
            return;
          }
          var t = window.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

          var scrollHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).height();
          var windowHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).height();
          if (t + windowHeight > scrollHeight - 100 && t > 0) {
            _this.infinite();
          }
        };
      }
    },
    infiniteDone: function infiniteDone() {
      this.infiniteLoading = false;
    },
    onScroll: function onScroll(e) {}
  },
  mounted: function mounted() {
    window.onceFlag = 0;
    this.infinite();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
    this.top = 0;
    this.state = 0;
    this.startY = 0;
    this.touching = false;
    this.infiniteLoadin = false;
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_imgs__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comments_commentOperation__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comments_commentOperation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__comments_commentOperation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__praiseDanner__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__praiseDanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__praiseDanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swiper_swiper__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swiper_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swiper_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tool_utils__ = __webpack_require__(3);









var _userAgent = window.navigator.userAgent;
var _agent = _userAgent.indexOf('xkyApp') === -1;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'discussDetail',
  props: ['discussItem', 'isDetail', 'sid'],
  data: function data() {
    return {
      isShowSwiper: 0,
      faceUrl: this.discussItem && this.discussItem.faceUrl ? this.discussItem.faceUrl : __WEBPACK_IMPORTED_MODULE_0__tool_imgs__["a" /* default */].comment_user_head_icon,
      limitImg: this.isDetail === 1 ? 9 : 3,
      errorImg: __WEBPACK_IMPORTED_MODULE_0__tool_imgs__["a" /* default */].comment_user_head_icon,
      isAndroidApp: !_agent && /(Android) | (Linux)/gi.test(_userAgent),

      ipSwitch: _ipSwitch == 1 && 1 || 0
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    detailShowSwiper: function detailShowSwiper(index) {
      var _this = this;
      _this.$emit('showSwiper', _this.discussItem.attUrls && _this.discussItem.attUrls.pics || '', index);
    },
    detailShowPopover: function detailShowPopover() {
      var _this = this;
      if (_agent) {
        this.$emit('detailShowPopover');
      } else {
        _this.$router.push({
          name: 'topicColumnDetail',
          params: { discussID: _this.discussItem.discussID, topicItem: _this.discussItem }
        });
      }
    },
    imgEorre: function imgEorre() {
      console.log('this', this);
      this.src = __WEBPACK_IMPORTED_MODULE_0__tool_imgs__["a" /* default */].comment_user_head_icon;
    },
    parseSpace: function parseSpace(t) {
      return __WEBPACK_IMPORTED_MODULE_4__tool_utils__["a" /* default */].parseSpace(t);
    },
    parseDateTime: function parseDateTime(t) {
      if (!t) return;
      return __WEBPACK_IMPORTED_MODULE_4__tool_utils__["a" /* default */].parseDateTime(t);
    },
    articleJumpUrl: function articleJumpUrl(articleType, articleID, columnID, linkID) {
      if (!articleType || !articleID) return;
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_4__tool_utils__["a" /* default */].articleJumpUrl(_this.sid, articleType, articleID, columnID, linkID);
    }
  },
  components: {
    commentOperation: __WEBPACK_IMPORTED_MODULE_1__comments_commentOperation___default.a,
    praiseDanner: __WEBPACK_IMPORTED_MODULE_2__praiseDanner___default.a,
    swiper: __WEBPACK_IMPORTED_MODULE_3__swiper_swiper___default.a
  },
  destroyed: function destroyed() {
    this.$emit('showSwiper');
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tool_submit__ = __webpack_require__(14);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'praiseDanner',
  props: ['discussItem'],
  filters: {
    parseCount: function parseCount(t) {
      if (!t) return;
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseCount(t);
    }
  },
  methods: {
    clickPares: function clickPares(item, n) {
      if (!item) return;
      var id = item.discussID;
      if ((localStorage.getItem('topicCommentPraise') || '').indexOf(id) > -1) return;
      var _this = this;

      var data = {
        sid: _this.$route.params.sid,
        discussID: id,
        uid: 0
      };
      __WEBPACK_IMPORTED_MODULE_1__tool_submit__["a" /* default */].clickPraise(data, n).then(function (res) {
        if (res && res.data) {
          if (n) {
            if ((localStorage.getItem('topicDiscussPraise') || '').indexOf(id) === -1) {
              localStorage.setItem('topicDiscussPraise', (localStorage.getItem('topicDiscussPraise') || '') + '_' + id);
            }
            _this.discussItem.curClass = 'news_comment_praise_img_active';
            _this.discussItem.praiseCount = res.data.praiseCount;
          }
        }
      }).catch(function (err) {
        console.log('clickPares-result-err', err);
      });
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_css_swiper_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_css_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_swiper_css_swiper_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tool_submit__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tool_utils__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['items', 'sid', 'topicID', 'uid'],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      swiperOption: {},
      list: []
    };
  },
  created: function created() {
    var _this = this;
    if (_this.$route.query.cid) {
      __WEBPACK_IMPORTED_MODULE_2__tool_submit__["a" /* default */].getTopicAdv({ cid: _this.$route.query.cid, sid: _this.sid, uid: _this.uid || '0' }).then(function (response) {
        if (response && response.data && response.data.length > 0) {
          var _list = [];
          for (var i = 0, len = response.data.length; i < len; i++) {
            var item = response.data[i];

            if (item.type == 12 && item.imgUrl) {
              item.imgUrl = __WEBPACK_IMPORTED_MODULE_2__tool_submit__["a" /* default */].handleImgScaleUrl(item.imgUrl, 'o');

              if (item.adTopicType == 1 || item.adTopicType == 0 && new RegExp('(\\b|,)' + _this.topicID + '(\\b|,)', 'g').test(item.adTopicIDs)) {
                if ((typeof item.adLinkType === 'undefined' || item.adLinkType == 1) && (item.contentUrl == null || item.contentUrl == '')) {
                  item.contentUrl = '';
                } else {
                  if (typeof item.adLinkType === 'undefined' || item.adLinkType == 1) {
                    if (item.contentUrl.indexOf('http') < 0) {
                      item.contentUrl = 'http://' + item.contentUrl;
                    }
                  } else {
                    item.contentUrl = __WEBPACK_IMPORTED_MODULE_3__tool_utils__["a" /* default */].articleJumpUrl(_this.sid, item.adLinkType == 5 && 104 || item.adArticleType, item.articleID, item.columnID || 0, item.articleLinkID, _this.$route.query.cid);
                  }
                }
              }
              _list.push(item);
            }
          }
          if (_list.length > 0) {
            _this.list = _list;
            _this.swiperOption = {
              initialSlide: 0,
              observeParents: true,
              autoplay: _list.length > 1 && 4000 || 0,
              autoHeight: true,
              onlyExternal: true,
              loop: _list.length > 1 && true || false
            };
          } else {
            _this.list = [];
          }
        } else {
          _this.list = [];
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_css_swiper_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_css_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_swiper_css_swiper_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['items', 'initIndex'],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: this.initIndex,
        pagination: '.swiper-pagination',

        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 0,
        zoom: true
      }
    };
  },
  mounted: function mounted() {
    if (this.items.length === 1) {
      document.getElementsByClassName('swiper-pagination-bullets')[0].style.display = 'none';
    }
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').css({ overflow: 'hidden' });
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Popover__);


var _userAgent = window.navigator.userAgent;
var _agent = _userAgent.indexOf('xkyApp') === -1;



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topBanner',
  props: ['appName', 'detail', 'topicInfo'],
  data: function data() {
    return {
      icon: '',
      sid: '',
      showPopover: 0,
      innerBanner: false,
      showBanner: _agent || 0
    };
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (_agent) {
      window.gUserConfig.downloadBarPosition = window.gUserConfig.downloadBarPosition || 0;

      if (window.gUserConfig.downloadBarPosition == 0) {
        this.innerBanner = false;
        this.showBanner = false;
      } else if (window.gUserConfig.downloadBarPosition == 1) {
        this.innerBanner = true;
        this.showBanner = true;
      } else {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        if (scrollTop > 50) {
          this.innerBanner = false;
        } else {
          this.innerBanner = true;
        }
        window.addEventListener('scroll', function () {
          if (scrollTop > 50) {
            _this2.innerBanner = false;
          } else {
            _this2.innerBanner = true;
          }
        });
      }
    }
  },

  watch: {
    appName: function appName(newValue, oldValue) {
      this.appName = newValue;
    }
  },
  created: function created() {
    this.sid = this.$route.params.sid;
    this.icon = 'https://' + this.sid + 'oss.newaircloud.com/global/user/' + this.sid + '/mobile/img/icon.png';
  },
  mounted: function mounted() {},

  methods: {
    openApp: function openApp(e) {
      var _this = this;

      _this.$emit('headToApp');
    },
    openTopic: function openTopic(n) {
      var _this = this;
      _this.showPopover = typeof n !== 'undefined' ? n : 1;
    },
    openAppOrTopic: function openAppOrTopic(e) {
      var _this = this;
      _this.$emit('topicDetail');
    }
  },
  components: {
    Popover: __WEBPACK_IMPORTED_MODULE_0__Popover___default.a
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__topBanner__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__topBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__topBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tool_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swiper_Adswiper__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swiper_Adswiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swiper_Adswiper__);






var _userAgent = window.navigator.userAgent;
var _agent = _userAgent.indexOf('xkyApp') === -1;
var _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') || /(Mobile)/gi.test(_userAgent);

var _isWX = /MicroMessenger\/([\d\.]+)/i.test(_userAgent);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['topicInfo', 'topicID', 'uid', 'bg', 'attention', 'themeColor', 'appName', 'sid', 'shareData'],
  data: function data() {
    return {
      isAppName: '关注',
      downAppHref: '',
      alertShow: false,
      clientHeight: (window.innerWidth || screen.width || document.documentElement.clientWidth || document.body.clientWidth) / 16 * 9 * 2 / 100,
      showSubmit: 0,
      topicDetailType: /^(0|1|2)$/.test(this.$route.query.topicDetailType) ? +this.$route.query.topicDetailType : 2,
      showMoreDes: 0,
      showMoreDesClass: 0,
      isWx: _isWX
    };
  },
  beforeMount: function beforeMount() {},

  components: {
    topBanner: __WEBPACK_IMPORTED_MODULE_0__topBanner___default.a,
    swiperAd: __WEBPACK_IMPORTED_MODULE_2__swiper_Adswiper___default.a
  },
  created: function created() {
    try {
      var str = this.topicInfo.endTime;
      str = str && (str + '').replace(/-/g, '/');

      this.showSubmit = new Date(str).getTime() - new Date().getTime() > 0 && (_userAgent.indexOf('xkyApp') > -1 && (this.sid == 'cxjrb' || this.sid == 'xkycs' || this.sid == 'trrb') || _isWX) || 0;
    } catch (e) {
      console.log(e);
    }
    if (this.appName && _agent) {
      this.isAppName = '\u6253\u5F00APP\u53C2\u4E0E\u8BA8\u8BBA';
    } else {
      this.isAppName = '关注';
    }
  },

  watch: {
    appName: function appName(newValue, oldValue) {
      if (this.appName && _agent && newValue != oldValue) {
        this.appName = newValue;

        this.isAppName = '\u6253\u5F00APP\u53C2\u4E0E\u8BA8\u8BBA';
      } else {
        this.isAppName = '关注';
      }
    },
    topicInfo: function topicInfo(newValue, oldValue) {
      try {
        var str = this.topicInfo.endTime;
        str = str && (str + '').replace(/-/g, '/');

        this.showSubmit = new Date(str).getTime() - new Date().getTime() > 0 && (_userAgent.indexOf('xkyApp') > -1 && (this.sid == 'cxjrb' || this.sid == 'xkycs' || this.sid == 'trrb') || _isWX) || 0;
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted: function mounted() {
    if (this.showMoreDes === 0) {
      if (this.$refs.desBoxss && this.$refs.desBoxss.offsetHeight && this.$refs.desBoxss.offsetHeight > 50) {
        this.showMoreDes = 1;
      } else {
        this.showMoreDes = 0;
      }
    }
  },
  beforeUpdate: function beforeUpdate() {},
  updated: function updated() {
    if (this.showMoreDes === 0) {
      if (this.$refs.desBoxss && this.$refs.desBoxss.offsetHeight && this.$refs.desBoxss.offsetHeight > 50) {
        this.showMoreDes = 1;
      } else {
        this.showMoreDes = 0;
      }
    }

    this.topicInfo.isShowAllTopics == 1 && __WEBPACK_IMPORTED_MODULE_1__tool_utils__["a" /* default */].wxLaunchChange('.previous-topics-main', this.headToApp, '', 1, '', this.shareData);

    if (_isWX && this.showSubmit && this.topicInfo.config && this.topicInfo.config.h5CloseDiscuss == 1) {
      __WEBPACK_IMPORTED_MODULE_1__tool_utils__["a" /* default */].wxLaunchChange('#submit-topic', this.headToApp, '', 1, '0.76rem', this.shareData);
    }
  },

  methods: {
    alertLogin: function alertLogin(e) {
      if (_agent && _isMobile) {
        this.$emit('topicToApp');
      } else {
        this.alertShow = true;
      }
    },
    alertCancle: function alertCancle() {
      this.alertShow = false;
    },
    alertSure: function alertSure(e) {
      this.$emit('topicToApp');
      this.alertShow = false;
    },
    headToApp: function headToApp() {
      this.$emit('topicToApp');
    },
    submitHref: function submitHref() {
      if (_isWX && this.showSubmit && this.topicInfo.config && this.topicInfo.config.h5CloseDiscuss == 1) {
        console.log('关了');
        return;
      }
      window.location.href = _isWX ? '/discussSubmit/' + this.topicID + '_' + this.sid + '.html' : 'jointopicdiscuss://?topicID=' + this.topicID + '&publishStatus=' + this.topicInfo.publishStatus;
    },

    parseSpace: function parseSpace(t) {
      return __WEBPACK_IMPORTED_MODULE_1__tool_utils__["a" /* default */].parseSpace(t);
    },
    showMoreDesChange: function showMoreDesChange() {
      console.log('showMoreDesChange', this.showMoreDesClass);
      this.showMoreDesClass = this.showMoreDesClass === 1 ? 0 : 1;
    }
  },
  computed: {
    timeShow: function timeShow() {
      var str = this.topicInfo.endTime;
      str = str && (str + '').replace(/-/g, '/');
      var curTime = new Date();
      var minuteTab = 60000;
      var hourTab = 3600000;
      var dateTab = 86400000;
      var leadTime = new Date(str).getTime() - curTime.getTime();
      if (leadTime > 3 * dateTab || leadTime < 0) {
        if (leadTime < 0) {
          str = '已关闭';
        } else {
          str = '';
        }
      } else if (leadTime > 2 * dateTab) {
        str = '2天后关闭';
      } else if (leadTime > dateTab) {
        str = '1天后关闭';
      } else if (leadTime > hourTab) {
        var leadTimeHour = parseInt(leadTime / hourTab);
        str = leadTimeHour + '\u5C0F\u65F6\u540E\u5173\u95ED';
      } else if (leadTime > minuteTab) {
        var leadTimeMinute = parseInt(leadTime / minuteTab);
        str = leadTimeMinute + '\u5206\u949F\u540E\u5173\u95ED';
      }
      return str;
    },

    styleComputed: function styleComputed(e) {
      if (this.bg) {
        return { backgroundImage: 'url( ' + this.bg.replace(/http:\/\/img\.newaircloud\.com/gi, 'https://img.newaircloud.com') + ')' };
      }
    }
  },
  filters: {
    parseCount: function parseCount(t) {
      if (!t) return;
      return __WEBPACK_IMPORTED_MODULE_1__tool_utils__["a" /* default */].parseCount(t);
    }
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_PullRefresh_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_PullRefresh_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_PullRefresh_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listhead_vue__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listhead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__listhead_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listcontent_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listcontent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__listcontent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__discussDetail_discussDetail__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__discussDetail_discussDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__discussDetail_discussDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tool_submit__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tool_utils__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['sid', 'govImage', 'topicID', 'themeColor'],
  data: function data() {
    return {
      topicLists: [],
      refreshList: [],
      busy: true,
      page: -1,
      pageSize: 10,
      loadingText: '加载中...',
      enableInfinite: true,
      once: false
    };
  },

  components: {
    listHead: __WEBPACK_IMPORTED_MODULE_1__listhead_vue___default.a,
    listContent: __WEBPACK_IMPORTED_MODULE_2__listcontent_vue___default.a,
    'pullScroll': __WEBPACK_IMPORTED_MODULE_0__common_PullRefresh_vue___default.a,
    discussDetail: __WEBPACK_IMPORTED_MODULE_3__discussDetail_discussDetail___default.a
  },
  watch: {
    topicLists: {
      handler: function handler(cur, old) {},

      deep: true
    }
  },
  mounted: function mounted() {

    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_5__tool_utils__["a" /* default */].videoPlayOne();
    }, 500);
  },

  methods: {
    onInfinite: function onInfinite(done) {
      var _this = this;
      _this.page++;

      __WEBPACK_IMPORTED_MODULE_4__tool_submit__["a" /* default */].getDiscussList({
        sid: _this.sid,
        topicID: _this.topicID,
        pageNum: _this.page
      }).then(function (response) {
        if (response.data && response.data.success) {
          _this.topicLists = _this.topicLists.concat(__WEBPACK_IMPORTED_MODULE_4__tool_submit__["a" /* default */].parseImageStyle(response.data.list, response.data.config));
          _this.$forceUpdate();
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_5__tool_utils__["a" /* default */].videoPlayOne();
          }, 500);
        }
        if (response.data.list && response.data.list.length === 10) {
          _this.enableInfinite = true;
        } else {
          if (typeof response.data.list === 'undefined') {
            _this.loadingText = '暂时没内容...';
          } else if (_this.topicLists.length >= 0) {
            _this.loadingText = '没有更多了...';
          } else {
            _this.loadingText = '加载中...';
          }
          _this.enableInfinite = false;
        }
        typeof done === 'function' && done();
      }).catch(function (error) {
        console.log(error);
      });
    },
    onRefresh: function onRefresh(refreshDone) {
      var _this2 = this;

      var _this = this;
      _this.once = true;
      _this.page = 0;
      __WEBPACK_IMPORTED_MODULE_4__tool_submit__["a" /* default */].getDiscussList({
        sid: _this.sid,
        topicID: _this.topicID,
        pageNum: 0
      }).then(function (response) {
        if (response.data && response.data.success) {
          _this.topicLists = _this2.topicLists.splice(0, 0).concat(__WEBPACK_IMPORTED_MODULE_4__tool_submit__["a" /* default */].parseImageStyle(response.data.list));
          _this.$forceUpdate();
        }
        if (response.data.list && response.data.list.length === 10) {
          _this.enableInfinite = true;
          _this.loadingText = '加载中...';
        } else {
          if (typeof response.data.list === 'undefined' || _this.topicLists.length === 0) {
            _this.loadingText = '暂时没内容...';
          } else if (_this.topicLists.length >= 0) {
            if (_this.topicLists.length === 0) {
              _this.loadingText = '暂时没内容...';
            } else {
              _this.loadingText = '没有更多了...';
            }
          } else {
            _this.loadingText = '加载中...';
          }
          _this.enableInfinite = false;
        }

        typeof refreshDone === 'function' && refreshDone();
      }).catch(function (error) {
        _this.loadingText = '暂时没内容...';
        console.log(error);
      });
    },
    detailShowSwiper: function detailShowSwiper(list, index) {
      this.$emit('topicShowSwiper', list, index);
    },
    detailShowPopover: function detailShowPopover() {
      this.$emit('showPopover');
    }
  },
  destroyed: function destroyed() {
    this.busy = true;
    this.page = -1;
    this.pageSize = 10;
    this.loadingText = '加载中...';
    this.enableInfinite = true;
    this.once = false;
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_utils__ = __webpack_require__(3);


var _userAgent = window.navigator.userAgent;
var _agent = _userAgent.indexOf('xkyApp') === -1;
var _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') > -1 || /(Mobile)/gi.test(_userAgent);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isImgShow: true,
      isTipShow: false,
      initIndex: 1,
      isBigImgShow: false,
      imgContainer: 'imgContainer1',
      contC: {
        content1: false,
        content2: true
      },
      imgC: {
        img1: true,
        img2: false,
        img3: false
      },
      isShare: false
    };
  },
  beforeMount: function beforeMount() {
    this.isShare = false;
  },
  mounted: function mounted() {
    if (this.isEmptyObject(this.attUrls)) {
      this.contC.content1 = true;
      this.contC.content2 = false;
      this.isImgShow = false;
      if (this.content.length > 88) {
        this.isTipShow = true;
      }
    } else {
      if (this.attUrls.pics.length >= 3) {
        this.imgC.img1 = false;
        this.imgC.img2 = false;
        this.imgC.img3 = true;
        this.imgContainer = 'imgContainer3';
        this.isTipShow = true;
      } else if (this.attUrls.pics.length > 1) {
        this.imgC.img1 = false;
        this.imgC.img2 = true;
        this.imgC.img3 = false;
        this.imgContainer = 'imgContainer2';
      }
    }
  },

  methods: {
    isEmptyObject: function isEmptyObject(obj) {
      for (var key in obj) {
        return false;
      }
      return true;
    },
    bigImage: function bigImage(index) {
      this.isBigImgShow = true;
      this.initIndex = index;
    },
    closeImg: function closeImg() {
      this.isBigImgShow = false;
    },
    openHrefApp: function openHrefApp() {
      window.location = sessionStorage.getItem('downAppHref');
    },

    parseSpace: function parseSpace(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseSpace(t);
    }
  },
  components: {},
  props: ['content', 'attUrls', 'discussID', 'topicItem'],
  beforeUpdate: function beforeUpdate() {},

  updated: function updated() {}
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tool_utils__ = __webpack_require__(3);



var _userAgent = window.navigator.userAgent;
var _agent = _userAgent.indexOf('xkyApp') === -1;
var _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') > -1 || /(Mobile)/gi.test(_userAgent);

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},

  props: ['topicItem', 'themeColor'],
  data: function data() {
    return {
      isShare: false
    };
  },
  beforeMount: function beforeMount() {
    if (_agent && _isMobile) {
      this.isShare = true;
    } else {
      this.isShare = false;
    }
  },

  filters: {
    parseDateTime: function parseDateTime(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseDateTime(t);
    }
  },
  methods: {
    parseSpace: function parseSpace(t) {
      return __WEBPACK_IMPORTED_MODULE_0__tool_utils__["a" /* default */].parseSpace(t);
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_swiper_swiper__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_swiper_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_swiper_swiper__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: [{ url: 'https://img.newaircloud.com/xkycs/upload/201706/30/c94792b6-1f94-427e-846f-fc2dee530611_00664.png' }, { url: 'https://img.newaircloud.com/xkycs/upload/201706/30/c94792b6-1f94-427e-846f-fc2dee530611_31895.png' }, { url: 'https://img.newaircloud.com/xkycs/upload/201706/30/c94792b6-1f94-427e-846f-fc2dee530611_21528.png' }, { url: 'https://img.newaircloud.com/xkycs/upload/201706/30/c94792b6-1f94-427e-846f-fc2dee530611_11148.png' }]
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0__components_swiper_swiper___default.a
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_topic_head__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_topic_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_topic_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topic_list__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topic_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_topic_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BottomOpenApp_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BottomOpenApp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BottomOpenApp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Popover__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tool_wxShare__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tool_utils__ = __webpack_require__(3);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['topicInfo', 'topicID', 'sid', 'uid', 'bg', 'attention', 'themeColor', 'appName'],
  data: function data() {
    return {
      popoverShow: 1,
      discussID: '',
      shareData: {}
    };
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_6__tool_utils__["a" /* default */].evokeAppInit(_this.sid, _this.topicID, _this.discussID, /^(0|1|2)$/.test(this.$route.query.topicDetailType) ? this.$route.query.topicDetailType + '' : '2', _this.$route.query.cid || 0);
  },
  mounted: function mounted() {
    this.discussID = this.$route.params.discussID;
    var _this = this;
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.topicInfo).length > 0 && _this.sid) {
      __WEBPACK_IMPORTED_MODULE_5__tool_wxShare__["a" /* default */].wxShare({
        sid: _this.sid,
        title: _this.topicInfo.title,
        desc: _this.topicInfo.description,
        imgUrl: _this.topicInfo.shareImg || _this.topicInfo.imgUrl });
    }
    var _shareData = {
      ti: document.title || '',
      aid: _this.$route.params.discussID || _this.$route.params.topicID,
      ty: _this.$route.params.discussID ? '105' : '104',
      id: _this.$route.params.discussID || _this.$route.params.topicID,
      sid: _this.$route.params.sid
    };
    if (!_this.discussID) {
      _shareData.topicDetailType = /^(0|1|2)$/.test(this.$route.query.topicDetailType) ? this.$route.query.topicDetailType + '' : '2';
    }
    if (_this.$route.query.cid) {
      _shareData.cid = _this.$route.query.cid || 0;
    }
    _this.shareData = _shareData;
    __WEBPACK_IMPORTED_MODULE_6__tool_utils__["a" /* default */].wxLaunchChange('#btnOpenAppBanner', _this.topicToApp, '', 1, '', _shareData);
    __WEBPACK_IMPORTED_MODULE_6__tool_utils__["a" /* default */].wxLaunchChange('.top-banner', _this.topicToApp, '', 1, '', _shareData);
  },

  watch: {
    appName: function appName(newValue, oldValue) {
      this.appName = newValue;
    },
    topicInfo: function topicInfo(newValue, oldValue) {
      this.topicInfo = newValue;
      var _this = this;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.topicInfo).length > 0 && _this.sid) {
        __WEBPACK_IMPORTED_MODULE_5__tool_wxShare__["a" /* default */].wxShare({
          sid: _this.sid,
          title: _this.topicInfo.title,
          desc: _this.topicInfo.description,
          imgUrl: _this.topicInfo.shareImg || _this.topicInfo.imgUrl });
      }
    }
  },
  methods: {
    topicToApp: function topicToApp(e) {
      this.$emit('downApp');
    },
    topicShowSwiper: function topicShowSwiper(list, index) {
      this.$emit('showSwiper', list, index);
    },
    showPopover: function showPopover(n) {
      this.popoverShow = n || 0;
    }
  },
  components: {
    headTop: __WEBPACK_IMPORTED_MODULE_1__components_topic_head___default.a,
    list: __WEBPACK_IMPORTED_MODULE_2__components_topic_list___default.a,
    BottomOpenApp: __WEBPACK_IMPORTED_MODULE_3__components_BottomOpenApp_vue___default.a,
    Popover: __WEBPACK_IMPORTED_MODULE_4__components_Popover___default.a
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_topBanner__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_topBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_topBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_comments_hotComments_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_comments_hotComments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_comments_hotComments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_comments_lastComments_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_comments_lastComments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_comments_lastComments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_discussDetail_discussDetail__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_discussDetail_discussDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_discussDetail_discussDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BottomOpenApp__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BottomOpenApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_BottomOpenApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CommentBox__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CommentBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_CommentBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tool_submit__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tool_wxShare_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tool_utils__ = __webpack_require__(3);















/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['topicInfo', 'bg', 'topicList', 'sid', 'govImage', 'themeColor', 'appName', 'item'],
  data: function data() {
    return {
      discussID: '',
      topicID: '',
      hotComments: {},
      isHotShow: false,
      lastComments: {},
      isLastShow: false,
      discussDetail: this.$route.params.topicItem,
      isShare: this.$route.params.topicItem || 0
    };
  },
  created: function created() {
    this.discussID = this.$route.params.discussID;
    this.topicID = this.$route.params.topicID;
    var _this = this;
    if (!this.$route.params.item) {
      __WEBPACK_IMPORTED_MODULE_7__tool_submit__["a" /* default */].getTopicDiscussContent({
        sid: _this.sid,
        discussID: this.discussID
      }).then(function (_ref) {
        var data = _ref.data;

        if (data) {
          document.title = data.title;
          var _item = [];
          _item.push(data);
          _item = __WEBPACK_IMPORTED_MODULE_7__tool_submit__["a" /* default */].parseImageStyle(_item, data.config || '');
          _this.discussDetail = _item && _item[0];
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.discussDetail).length > 0 && _this.sid) {
            __WEBPACK_IMPORTED_MODULE_8__tool_wxShare_js__["a" /* default */].wxShare({
              sid: _this.sid,
              title: (_this.sid === 'tzwb' || _this.sid === 'test') && _this.discussDetail.content || _this.discussDetail.title,
              desc: _this.discussDetail.content,
              imgUrl: _this.discussDetail.imgUrl });
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    } else {
      try {
        __WEBPACK_IMPORTED_MODULE_8__tool_wxShare_js__["a" /* default */].wxShare({
          sid: _this.sid,
          title: (_this.sid === 'tzwb' || _this.sid === 'test') && _this.discussDetail.content || _this.discussDetail.title,
          desc: _this.discussDetail.content,
          imgUrl: _this.discussDetail.imgUrl });
      } catch (e) {
        console.log(e);
      }
    }
    __WEBPACK_IMPORTED_MODULE_7__tool_submit__["a" /* default */].getHotComments({
      sid: _this.sid,
      rootID: _this.discussID,
      sourceType: 5,
      lastFileID: 0,
      rowNumber: 0,
      userID: -1
    }).then(function (_ref2) {
      var data = _ref2.data;

      if (data && data.list) {
        _this.hotComments = data.list;
        if (_this.hotComments.length > 0) {
          _this.isHotShow = true;
        }
      }
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_7__tool_submit__["a" /* default */].getComments({
      sid: _this.sid,
      rootID: _this.discussID,
      sourceType: 5,
      lastFileID: 0,
      rowNumber: 0,
      _userID: -1
    }).then(function (_ref3) {
      var data = _ref3.data;

      if (data && data.list) {
        _this.lastComments = data.list;
        if (_this.lastComments.length > 0) {
          _this.isLastShow = true;
        }
      }
    }).catch(function (error) {
      console.log(error);
    });

    __WEBPACK_IMPORTED_MODULE_9__tool_utils__["a" /* default */].evokeAppInit(_this.sid, _this.topicID, _this.discussID);
  },
  mounted: function mounted() {
    var _this = this;
    var _shareData = {
      ti: document.title || '',
      aid: _this.$route.params.discussID || _this.$route.params.topicID,
      ty: _this.$route.params.discussID ? '105' : '104',
      id: _this.$route.params.discussID || _this.$route.params.topicID,
      sid: _this.$route.params.sid
    };
    __WEBPACK_IMPORTED_MODULE_9__tool_utils__["a" /* default */].wxLaunchChange('#btnOpenAppBanner', _this.topicDetail, '', 1, '', _shareData);
  },

  components: {
    topBanner: __WEBPACK_IMPORTED_MODULE_1__components_topBanner___default.a,
    hotComments: __WEBPACK_IMPORTED_MODULE_2__components_comments_hotComments_vue___default.a,
    lastComments: __WEBPACK_IMPORTED_MODULE_3__components_comments_lastComments_vue___default.a,
    discussDetail: __WEBPACK_IMPORTED_MODULE_4__components_discussDetail_discussDetail___default.a,
    BottomOpenApp: __WEBPACK_IMPORTED_MODULE_5__components_BottomOpenApp___default.a,
    CommentBox: __WEBPACK_IMPORTED_MODULE_6__components_CommentBox___default.a
  },
  methods: {
    topicDetail: function topicDetail(e) {
      this.$emit('downApp', 'topicColumnDetail.vue ' + e);
    },
    showSwiper: function showSwiper(list, index) {
      this.$emit('showSwiper', list, index);
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(141);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__["a" /* default */], {
  preLoad: 1.3,
  loading: 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg=='
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  comment_user_head_icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABTCAMAAADUbMsyAAAAt1BMVEUAAAC1t7ejo6O1tra2tra2t7e1tbW0tbW1tra1tra1tra/v7+0tbW3uLi3uLi1tra1t7e1tra1tra1tra1tbW0t7e3uLi2t7e0tbW1tra0tra1t7eqqqq0tra1tbW2trafv7+1trb////8/Py2t7e4ubn5+vr39/f19fW9vr67vLy6u7vy8vLj4+PJycnc3d3f4ODX19e/wMDu7+/T1NTFxsbBwsLq6+va2trOz8/LzMzn5+fR0dEEluuoAAAAIXRSTlMAOQPu5eAwGpDLrgj5+PLYzcdmY1pYzbFLnpKDCZ2DSQiEePxFAAAEAklEQVRYw62Zh3raMBCAcRkJI5QVyGwrW5JleS9sDO//XHWJ29DkTjJu/wf4P43T6XTq6Zgaq9vJdji/o3fz4XZyuzKmvX/hi/G8nJGPzJbPxpeOxtHtgGAMnkYdhrgZEzXjzZfrjOsh0TNcX2F9+Era8fWhpfFmQtozuWmjvO+Ta+jfa40/Xsm1vP7QzHtMrmesnP9oQLowUASr0Sfd6BsdlF2lo1rZXToCtwdfS+pKp0a6VLGmwEa9LAiCu8/81BPCS/1s76LSxcsn5yOBYXkkuGWesbjwK9T6+On0ILPeR6IRNlrbz7EVuP+wmH1YWaWN8R3LOzBkn/5e0gmsPAgTQMTI/CeXyu/IKIUJYsfISB8uUjCcL3PPRBABkk/fk/SaQDiFiVI4sHT9Z5hDcOYxx50cmf3w90A3BGKfmgq8hIBsGucYjPXSwo34QMdN7iAQsjCVFJKAvOWSW3jqQu0UOex8Ou/QAA53rnbyE4Xz069dMuDUEWucVonEvVE7v8HO0NI4feSAfqudy//sXNb15ew/O2dTZDnr8NQ5Q0awBV0REJrp9j2jiHNVRydMYKuddkAQbns7AuOkaqeXYM5db0tgWGQplzNimHPbQwviQKicIsDL596cILiRpY4kjHnvjmDsPWUGQbnrUYJBM1uVPVGoYpzEDS1s5pKoxjknOA68pNYxIQrm9b4rpRyYuL8nKoZ1fKpws9T6WNrEkijZ1udICU1Kj78buRfuGVGzq8+7BpacjsK2Oee2OGZqY3PeV0QLlUleZdkhSCQlelZA/kTElJJ2GFie787sBbuPurNE783uPAP3OwSlrKbdihpNHYLDXCfZB6esDMMyPlV54khGGvA6BI9Q6iZV7Kfn4LRqOLdt4R3jShVTT0hd18T6wfds63MWeYt9LCeP0PqTyiDyOJ7ouYgCCdafaJ0sD4WtqxlsvwKsG6SeZ8ERyPCQNXCBeh54d9AkFMAYYWu0p+SSNfg+YocUMKJW7yTB99HlO84JbfMq+OVQH4D3Js2PlnklVhH8lk6AdzENgHnr8U4Mehef3++08sxO2G9X1D3QZwjaKPGH8iPQD6GVYnv0RfPiBerbuCXvqIycum8D95dkyLsq+yOsDybLDtPnkaNsrrmxuHp/QlkrVX1F5GjiiMxt+ooYNwv0KOGHaKHp/05fiVO2zkuidOq4nLboJ7Pcb7VVdf5kQD8Z6XvXeZ5rt7s4SKDvjffnqXM42pYqGxcnh8L9efwfgco8TG0LFnp+ICnwj6D/72BOUKbnu/2PzbK4nYaV44L/HXpGT4Namx/i0D8WnhAiLfyozHKHaf5l9P9HlDJXSidJfjV/GaMd/o+gf67dovnnWuza/HP9BN680C9YHzRZAAAAAElFTkSuQmCC'
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var domain = '';

var _TOKEN = domain + '/api/getAppToken';

var _GETTOPICINFO = domain + '/topicApi/getTopicInfoDy';

var _SUBEVENT = domain + '/api/subEventDy';

var _DISCUSSPRAISE = domain + '/topicApi/discussPraiseDy';

var _GETCONFIG = domain + '/api/getConfigDy';

var _GETTOPICDISCUSSCONTENT = domain + '/topicApi/getTopicDiscussContentDy';

var _GETHOTCOMMENTS = domain + '/api/getHotCommentsDy';

var _GETCOMMENTS = domain + '/api/getCommentsDy';

var _GETDISCUSSLIST = domain + '/topicApi/getDiscussListDy';

var _SUBMITCOMMENT = domain + '/api/submitCommentDy';

var _GETTOPICADV = domain + '/topicApi/getTopicAdv';

/* harmony default export */ __webpack_exports__["a"] = ({
  _TOKEN: _TOKEN,
  _GETTOPICINFO: _GETTOPICINFO,
  _SUBEVENT: _SUBEVENT,
  _DISCUSSPRAISE: _DISCUSSPRAISE,
  _GETCONFIG: _GETCONFIG,
  _GETTOPICDISCUSSCONTENT: _GETTOPICDISCUSSCONTENT,
  _GETHOTCOMMENTS: _GETHOTCOMMENTS,
  _GETCOMMENTS: _GETCOMMENTS,
  _GETDISCUSSLIST: _GETDISCUSSLIST,
  _SUBMITCOMMENT: _SUBMITCOMMENT,
  _GETTOPICADV: _GETTOPICADV
});

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(313),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(331),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d767ef06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(319),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3db53a12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(320),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f7a0c84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(314),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(326),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-793abd16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(323),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(325),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(310),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-047c35ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(330),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bf97414c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(321),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4223904f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(316),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(324),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(317),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out"
  }, [_c('pullScroll', {
    attrs: {
      "on-refresh": _vm.onRefresh,
      "on-infinite": _vm.onInfinite,
      "loading-text": _vm.loadingText,
      "enableInfinite": _vm.enableInfinite
    }
  }, [_c('ul', {
    attrs: {
      "id": "topicList"
    }
  }, _vm._l((_vm.topicLists), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('discussDetail', {
      attrs: {
        "discussItem": item,
        "sid": _vm.sid
      },
      on: {
        "showSwiper": _vm.detailShowSwiper,
        "detailShowPopover": _vm.detailShowPopover
      }
    })], 1)
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showBanner) ? _c('div', {
    staticClass: "top-banner-out"
  }, [(_vm.innerBanner) ? _c('div', {
    staticClass: "top-banner"
  }, [_c('div', {
    staticClass: "t-app"
  }, [(_vm.icon) ? _c('img', {
    attrs: {
      "onerror": "this.style.display='none'",
      "src": _vm.icon,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appName) ? _c('span', {
    staticClass: "app-name"
  }, [_vm._v(_vm._s(_vm.appName))]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.detail) ? _c('span', {
    staticClass: "to-app openappAndroidwx wx-launch-app-btn-parent"
  }, [_vm._v("打开APP参与话题")]) : _vm._e(), _vm._v(" "), (_vm.detail) ? _c('span', {
    staticClass: "to-app",
    on: {
      "click": _vm.openTopic
    }
  }, [_vm._v("查看完整话题")]) : _vm._e(), _vm._v(" "), (_vm.showPopover) ? _c('Popover', {
    attrs: {
      "appName": _vm.appName,
      "topicInfo": _vm.topicInfo
    },
    on: {
      "openAppOrTopic": _vm.openAppOrTopic,
      "openTopic": _vm.openTopic
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-tip"
  }, [_c('span', {
    staticClass: "t-line"
  }), _vm._v(" "), _c('span', {
    staticClass: "t-w"
  }, [_vm._v("话题")])])
}]}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "hot_content"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item.commentID + '' + index
    }, [_c('div', {
      staticClass: "hot-comment-top"
    }, [_c('div', {
      staticClass: "conTop_left"
    }, [_c('div', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "conTop_img",
      style: ({
        backgroundImage: ("url(" + ((item.type === 2 || item.userID === -1 || item.userID === 0 || item.userID === -3) && _vm.govImage ? _vm.govImage : item.faceUrl) + ")")
      })
    }), _vm._v(" "), (item.commentOfficial && (item.type === 2 || item.userID === -1 || item.userID === 0 || item.userID === -3)) ? _c('img', {
      staticClass: "conTop_img-official",
      attrs: {
        "src": item.commentOfficial,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "conTop_name"
    }, [_c('p', {
      staticClass: "conTop_name_user themeColor",
      domProps: {
        "innerHTML": _vm._s(_vm.parseSpace((item.type === 2 || item.userID === -1 || item.userID === 0 || item.userID === -3) && !item.userName ? '官方发布' : item.userName))
      }
    })])]), _vm._v(" "), _c('commentOperation', {
      attrs: {
        "item": item
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "conContent",
      domProps: {
        "innerHTML": _vm._s(_vm.parseSpace(item.content))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "c-createTime"
    }, [_vm._v("\n        " + _vm._s(_vm._f("parseDateTime")(item.createTime)) + "\n        "), _c('span', {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(_vm._f("parseDateTime")(item.createTime)))]), _vm._v(" "), (_vm.ipSwitch == 1 && item.ip) ? _c('span', {
      staticStyle: {
        "display": "inline-block"
      },
      domProps: {
        "textContent": _vm._s(!item.ipAddress && 'IP：未知' || 'IP：' + item.ipAddress)
      }
    }) : _vm._e()]), _vm._v(" "), (item.parentID > 0 && item.parentContent) ? _c('div', {
      staticClass: "news_comment_reply_info"
    }, [_c('div', {
      staticClass: "news_comment_reply_info_top"
    }, [_c('p', {
      staticClass: "news_comment_nickname",
      domProps: {
        "innerHTML": _vm._s(_vm.parseSpace(item.parentUserName))
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "news_comment_text",
      domProps: {
        "innerHTML": _vm._s(_vm.parseSpace(item.parentContent))
      }
    })]) : _vm._e()])
  }))
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yo-scroll",
    class: {
      'down': (_vm.state === 0), 'up': (_vm.state == 1), refresh: (_vm.state === 2), touch: _vm.touching, finish: (_vm.state === 3)
    },
    on: {
      "touchstart": function($event) {
        _vm.touchStart($event)
      },
      "touchmove": function($event) {
        _vm.touchMove($event)
      },
      "touchend": function($event) {
        _vm.touchEnd($event)
      },
      "scroll": function($event) {
        (_vm.onInfinite || _vm.infiniteLoading) ? _vm.onScroll($event): undefined
      }
    }
  }, [_c('div', {
    staticClass: "inner",
    style: ({
      transform: 'translate3d(0, ' + _vm.top + 'px, 0)'
    })
  }, [_c('header', {
    staticClass: "pull-refresh"
  }, [_vm._t("pull-refresh", [_c('span', {
    staticClass: "down-tip"
  }, [_vm._v("下拉刷新")]), _vm._v(" "), _c('span', {
    staticClass: "up-tip"
  }, [_vm._v("松开更新")]), _vm._v(" "), _c('span', {
    staticClass: "refresh-tip"
  }, [_vm._v("正在更新中")]), _vm._v(" "), _c('span', {
    staticClass: "finish-tip"
  }, [_vm._v("更新完成")])])], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('footer', {
    staticClass: "load-more"
  }, [_vm._t("load-more", [_c('span', [_vm._v(_vm._s(_vm.loadingText))])])], 2)], 2)])
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_comment_operation ",
    class: {
      news_comment_operation_new: _vm.isDetail == 3
    }
  }, [(_vm.isDetail == 30000000) ? _c('div', {
    staticClass: "news_comment_operation_3"
  }, [_c('svg', {
    staticClass: "message",
    attrs: {
      "viewBox": "0 0 1194 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "37.3125",
      "height": "32",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    on: {
      "click": function($event) {
        _vm.clickShowPopover()
      }
    }
  }, [_c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M333.824 509.496889c32.369778 0 58.595556-25.486222 58.595556-56.888889 0-31.459556-26.225778-56.888889-58.595556-56.888889-32.312889 0-58.538667 25.429333-58.538667 56.888889 0 31.402667 26.168889 56.888889 58.595556 56.888889zM599.324444 509.496889c32.369778 0 58.595556-25.486222 58.595556-56.888889 0-31.459556-26.225778-56.888889-58.595556-56.888889-32.312889 0-58.595556 25.429333-58.595555 56.888889 0 31.402667 26.282667 56.888889 58.595555 56.888889zM864.824889 509.496889c32.312889 0 58.595556-25.486222 58.595555-56.888889 0-31.459556-26.282667-56.888889-58.595555-56.888889-32.369778 0-58.595556 25.429333-58.595556 56.888889 0 31.402667 26.225778 56.888889 58.595556 56.888889z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M691.484444 844.003556a138.808889 138.808889 0 0 1 98.360889-40.846223h247.011556a55.751111 55.751111 0 0 0 55.751111-55.751111V184.547556a55.751111 55.751111 0 0 0-55.751111-55.751112H167.992889a55.751111 55.751111 0 0 0-55.751111 55.751112v562.858666c0 30.776889 24.917333 55.751111 55.751111 55.751111h246.044444a138.808889 138.808889 0 0 1 95.345778 37.944889l95.288889 90.112 86.812444-87.210666zM167.992889 54.840889h868.864a129.706667 129.706667 0 0 1 129.706667 129.706667v562.858666a129.706667 129.706667 0 0 1-129.706667 129.706667h-247.011556c-17.237333 0-33.792 6.826667-45.966222 19.114667l-93.070222 93.468444a64.853333 64.853333 0 0 1-90.510222 1.365333L458.581333 894.862222a64.853333 64.853333 0 0 0-44.544-17.749333H167.992889a129.706667 129.706667 0 0 1-129.706667-129.706667V184.547556a129.706667 129.706667 0 0 1 129.706667-129.706667z"
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.commentCount && _vm.item.commentCount > 0),
      expression: "item.commentCount && item.commentCount>0"
    }],
    staticClass: "news_comment_praise_count",
    class: 'no_news_comment_praise_count_discuss_' + _vm.item.commentID
  }, [_vm._v(_vm._s(_vm._f("parseCount")(_vm.item.commentCount)))]), _vm._v(" "), _c('svg', {
    staticClass: "news_comment_praise_img list-praise",
    class: _vm.item.curClass,
    staticStyle: {
      "enable-background": "new 0 0 32 32"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32 32",
      "xml:space": "preserve"
    },
    on: {
      "click": function($event) {
        _vm.clickPares(_vm.item.curClass == 'news_comment_praise_img_active' ? '' : _vm.item, 1)
      }
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M29.2,10.5c-1.2-0.3-4.2-0.3-8.5-0.4c0.2-0.9,0.2-1.8,0.2-3.3C20.9,3.2,18.3,0,16,0c-1.6,0-3,1.3-3,3\n                                        c0,2-0.6,5.5-4,7.3c-0.2,0.1-1,0.5-1.1,0.5H8C7.5,10.3,6.7,10,6,10H3c-1.7,0-3,1.3-3,3v16c0,1.7,1.3,3,3,3h3c1.2,0,2.2-0.7,2.7-1.7\n                                        l0,0c0.1,0,0.1,0,0.2,0.1l0,0c0.6,0.1,1.7,0.4,4.1,1c0.5,0.1,3.2,0.7,6,0.7h5.5c1.7,0,2.9-0.6,3.6-1.9c0,0,0.2-0.5,0.4-1.1\n                                        c0.1-0.5,0.2-1.1,0-1.8c1.1-0.7,1.4-1.9,1.6-2.6c0.4-1.2,0.3-2.1,0-2.7c0.6-0.6,1.1-1.4,1.3-2.8c0.1-0.8,0-1.7-0.4-2.4\n                                        c0.6-0.6,0.8-1.4,0.9-2.2v-0.2c0-0.1,0-0.2,0-0.5C32,12.6,31.1,11,29.2,10.5z M7,29c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V13\n                                        c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1V29z M30,14.5c0,0.5-0.2,1.5-2,1.5c-1.5,0-2,0-2,0c-0.3,0-0.5,0.2-0.5,0.5S25.7,17,26,17\n                                        c0,0,0.4,0,1.9,0s1.7,1.2,1.6,1.8C29.4,19.5,29,21,27.3,21s-2.4,0-2.4,0c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c0,0,1.2,0,2,0\n                                        c1.7,0,1.5,1.3,1.3,2.1c-0.3,1-0.5,1.9-2.6,1.9c-0.7,0-1.6,0-1.6,0c-0.3,0-0.5,0.2-0.5,0.5S23.7,27,24,27c0,0,0.7,0,1.6,0\n                                        c1.1,0,1.1,1,1,1.4s-0.3,0.7-0.3,0.7C26,29.7,25.5,30,24.5,30H19c-2.7,0-5.5-0.6-5.5-0.6c-4.2-1-4.4-1-4.6-1.1c0,0-0.8-0.1-0.8-0.9\n                                        V13.6c0-0.5,0.3-0.9,0.8-1c0.1,0,0.1,0,0.2-0.1c4.6-1.9,6-6,6-9.4c0-0.5,0.4-1,1-1c1.1,0,2.9,2.1,2.9,4.7c0,2.4-0.1,2.8-0.9,5.3\n                                        c10,0,9.9,0.1,10.8,0.4c1.1,0.3,1.2,1.2,1.2,1.5C30,14.2,30,14.2,30,14.5z M32,32H0H32V0V32z"
    }
  })])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.praiseCount && _vm.item.praiseCount > 0),
      expression: "item.praiseCount && item.praiseCount>0"
    }],
    staticClass: "news_comment_praise_count ",
    class: 'news_comment_praise_count_discuss_' + _vm.item.discussID
  }, [_vm._v(_vm._s(_vm._f("parseCount")(_vm.item.praiseCount)))])]) : _vm._e(), _vm._v(" "), (_vm.isDetail == 3) ? _c('div', {
    staticClass: "news_comment_operation_3 news_comment_operation_3_new"
  }, [(_vm.showCommentBanner == 1) ? _c('div', {
    staticClass: "commentBanner"
  }, [_c('span', {
    staticClass: "news_comment_praise_span_count cursor",
    class: _vm.item.curClass,
    on: {
      "click": function($event) {
        _vm.clickPares(_vm.item.curClass == 'news_comment_praise_img_active' ? '' : _vm.item, 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.item.praiseCount && _vm.item.praiseCount > 0 && (_vm.item.praiseCount | _vm.parseCount) + ' ' || '') + "赞")]), _vm._v(" "), _c('span', {
    staticClass: "comment-m"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "comment-r cursor",
    on: {
      "click": function($event) {
        _vm.clickShowPopover()
      }
    }
  }, [_vm._v("评论")])]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "cursor",
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAP1BMVEUAAACZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiampqXl5efn5+ZmZk3xg50AAAAFHRSTlMA8SrYsvfrrZaPIgwHu9WmUlEsELeTK80AAADFSURBVFjD7ZZLDoMwDERth09CIIWQ+5+1Gmi7KUUiXrSq/BZBs/BDwSyGDOOJBNeWi7QuCO2MvlTix21+KtVMMPiiwBMJnm6OdJE4O0wKBcyvVMEKQyCcC1Wx4N2E/UWqImKbhItQJZg1gQn+VCA9cz+8UvOW5FwgjNwNnxPLqaApG7ejNO2pORVw2ej21B4lVgvUV1B/RO0af/5PNIEJviPQFgzWVpxEAaemZOXqmpcwmbVFU1919WUb5JC4XIRTyGQYD+6af0baPnzroAAAAABJRU5ErkJggg==",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.clickShowCommentBanner()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isDetail != 3 && _vm.isDetail != 9) ? _c('div', {
    staticClass: "news_comment_operation_3"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.countPraise && _vm.item.countPraise > 0),
      expression: "item.countPraise && item.countPraise>0"
    }],
    staticClass: "news_comment_praise_count comment_new",
    class: 'news_comment_praise_count_' + _vm.item.commentID
  }, [_vm._v(_vm._s(_vm._f("parseCount")(_vm.item.countPraise)))]), _vm._v(" "), _c('svg', {
    staticClass: "news_comment_praise_img",
    class: _vm.item.curClass,
    staticStyle: {
      "enable-background": "new 0 0 32 32"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32 32",
      "xml:space": "preserve"
    },
    on: {
      "click": function($event) {
        _vm.clickPares(_vm.item.curClass == 'news_comment_praise_img_active' ? '' : _vm.item)
      }
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M29.2,10.5c-1.2-0.3-4.2-0.3-8.5-0.4c0.2-0.9,0.2-1.8,0.2-3.3C20.9,3.2,18.3,0,16,0c-1.6,0-3,1.3-3,3\n                                        c0,2-0.6,5.5-4,7.3c-0.2,0.1-1,0.5-1.1,0.5H8C7.5,10.3,6.7,10,6,10H3c-1.7,0-3,1.3-3,3v16c0,1.7,1.3,3,3,3h3c1.2,0,2.2-0.7,2.7-1.7\n                                        l0,0c0.1,0,0.1,0,0.2,0.1l0,0c0.6,0.1,1.7,0.4,4.1,1c0.5,0.1,3.2,0.7,6,0.7h5.5c1.7,0,2.9-0.6,3.6-1.9c0,0,0.2-0.5,0.4-1.1\n                                        c0.1-0.5,0.2-1.1,0-1.8c1.1-0.7,1.4-1.9,1.6-2.6c0.4-1.2,0.3-2.1,0-2.7c0.6-0.6,1.1-1.4,1.3-2.8c0.1-0.8,0-1.7-0.4-2.4\n                                        c0.6-0.6,0.8-1.4,0.9-2.2v-0.2c0-0.1,0-0.2,0-0.5C32,12.6,31.1,11,29.2,10.5z M7,29c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V13\n                                        c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1V29z M30,14.5c0,0.5-0.2,1.5-2,1.5c-1.5,0-2,0-2,0c-0.3,0-0.5,0.2-0.5,0.5S25.7,17,26,17\n                                        c0,0,0.4,0,1.9,0s1.7,1.2,1.6,1.8C29.4,19.5,29,21,27.3,21s-2.4,0-2.4,0c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c0,0,1.2,0,2,0\n                                        c1.7,0,1.5,1.3,1.3,2.1c-0.3,1-0.5,1.9-2.6,1.9c-0.7,0-1.6,0-1.6,0c-0.3,0-0.5,0.2-0.5,0.5S23.7,27,24,27c0,0,0.7,0,1.6,0\n                                        c1.1,0,1.1,1,1,1.4s-0.3,0.7-0.3,0.7C26,29.7,25.5,30,24.5,30H19c-2.7,0-5.5-0.6-5.5-0.6c-4.2-1-4.4-1-4.6-1.1c0,0-0.8-0.1-0.8-0.9\n                                        V13.6c0-0.5,0.3-0.9,0.8-1c0.1,0,0.1,0,0.2-0.1c4.6-1.9,6-6,6-9.4c0-0.5,0.4-1,1-1c1.1,0,2.9,2.1,2.9,4.7c0,2.4-0.1,2.8-0.9,5.3\n                                        c10,0,9.9,0.1,10.8,0.4c1.1,0.3,1.2,1.2,1.2,1.5C30,14.2,30,14.2,30,14.5z M32,32H0H32V0V32z"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('swiper', {
    attrs: {
      "items": _vm.items
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topicColumnDetail"
    }
  }, [(!_vm.isShare) ? _c('topBanner', {
    attrs: {
      "appName": _vm.appName,
      "detail": 1
    },
    on: {
      "topicDetail": _vm.topicDetail
    }
  }) : _vm._e(), _vm._v(" "), (_vm.discussDetail) ? _c('discussDetail', {
    attrs: {
      "discussItem": _vm.discussDetail,
      "isDetail": 1
    },
    on: {
      "showSwiper": _vm.showSwiper
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "topicDetailComments"
  }, [(_vm.isHotShow && _vm.hotComments) ? _c('hot-comments', {
    attrs: {
      "hotComments": _vm.hotComments,
      "govImage": _vm.govImage,
      "themeColor": _vm.themeColor
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLastShow && _vm.lastComments) ? _c('last-comments', {
    attrs: {
      "lastComments": _vm.lastComments,
      "govImage": _vm.govImage,
      "themeColor": _vm.themeColor
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isHotShow === false && _vm.isLastShow === false) ? _c('div', {
    staticClass: "noComments"
  }, [_c('svg', {
    staticStyle: {
      "width": "0.68rem",
      "height": "0.68rem"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 68 68"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "fill": "rgb(221, 221, 221)",
      "d": "M59.304,58.292 L61.874,60.866 C63.383,62.376 63.627,64.580 62.422,65.787 C61.213,66.998 59.013,66.753 57.505,65.243 L52.040,59.769 C52.036,59.765 52.033,59.760 52.028,59.755 C51.460,59.185 50.694,58.858 49.889,58.847 L17.886,58.847 L17.845,58.847 C17.060,58.846 16.304,59.145 15.731,59.683 L15.731,59.683 C15.704,59.711 15.684,59.742 15.657,59.769 L10.193,65.243 C8.684,66.753 6.484,66.998 5.279,65.790 C4.070,64.583 4.314,62.376 5.823,60.866 L7.943,58.742 C6.225,58.493 4.591,57.772 3.244,56.617 C1.185,54.853 -0.000,52.275 -0.000,49.561 L-0.000,30.988 C-0.000,26.947 2.582,23.518 6.181,22.242 L6.181,9.320 C6.181,4.192 10.332,0.034 15.453,0.034 L52.541,0.034 C57.662,0.034 61.813,4.192 61.813,9.320 L61.813,22.242 C65.412,23.518 67.994,26.947 67.994,30.988 L67.994,46.465 C67.994,52.023 64.339,56.725 59.304,58.292 ZM55.631,12.416 C55.631,10.774 54.980,9.199 53.821,8.038 C52.662,6.877 51.090,6.225 49.450,6.225 L18.544,6.225 C16.904,6.225 15.332,6.877 14.173,8.038 C13.014,9.199 12.363,10.774 12.363,12.416 L12.363,22.242 C15.961,23.518 18.544,26.947 18.544,30.988 L18.544,35.632 C18.544,36.042 18.707,36.436 18.996,36.726 C19.286,37.016 19.679,37.179 20.089,37.179 L47.905,37.179 C48.315,37.179 48.708,37.016 48.998,36.726 C49.287,36.436 49.450,36.042 49.450,35.632 L49.450,30.988 C49.450,26.947 52.033,23.518 55.631,22.242 L55.631,12.416 ZM61.813,30.988 C61.813,29.279 60.429,27.893 58.722,27.893 C57.015,27.893 55.632,29.279 55.631,30.988 L55.631,40.275 L55.631,41.822 C55.631,42.233 55.469,42.626 55.179,42.917 C54.889,43.207 54.496,43.370 54.086,43.370 L13.908,43.370 C13.498,43.370 13.105,43.207 12.815,42.917 C12.525,42.626 12.363,42.233 12.363,41.822 L12.363,30.988 C12.362,29.279 10.979,27.893 9.272,27.893 C7.565,27.893 6.181,29.279 6.181,30.988 L6.181,49.561 C6.181,51.270 7.565,52.656 9.272,52.656 L58.722,52.656 C60.429,52.656 61.813,51.270 61.813,49.561 L61.813,30.988 ZM44.814,30.988 L23.180,30.988 C22.149,30.988 21.634,30.472 21.634,29.441 C21.634,28.409 22.149,27.893 23.180,27.893 L44.814,27.893 C45.845,27.893 46.360,28.409 46.360,29.441 C46.360,30.472 45.845,30.988 44.814,30.988 Z"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#999999",
      "font-size": "0.28rem",
      "line-height": "0.48rem"
    }
  }, [_vm._v("暂无评论内容")])]) : _vm._e(), _vm._v(" "), _c('BottomOpenApp', {
    on: {
      "topicToApp": _vm.topicDetail
    }
  }), _vm._v(" "), _c('CommentBox', {
    attrs: {
      "topicInfo": _vm.topicInfo,
      "sid": _vm.sid,
      "discussID": _vm.discussID
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "border-top": "0.1rem solid #ededed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hotComments"
  }, [_vm._m(0), _vm._v(" "), _c('commentContent', {
    attrs: {
      "items": _vm.hotComments,
      "govImage": _vm.govImage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot_top"
  }, [_c('div', {
    staticClass: "hotLogo"
  }, [_vm._v("热门评论")])])
}]}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "border-top": "0.1rem solid #ededed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lastComments"
  }, [_vm._m(0), _vm._v(" "), _c('commentContent', {
    attrs: {
      "items": _vm.lastComments,
      "govImage": _vm.govImage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "last_top"
  }, [_c('div', {
    staticClass: "lastLogo"
  }, [_vm._v("最新评论")])])
}]}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isShare) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.topicItem.discussID
        }
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "listHead"
    }
  }, [_c('div', {
    staticClass: "listHead"
  }, [_c('div', {
    staticClass: "listHead_left"
  }, [(_vm.topicItem.faceUrl !== '' && _vm.topicItem.faceUrl && _vm.topicItem.faceUrl.length > 0) ? _c('div', {
    staticClass: "listHead_img",
    style: ({
      backgroundImage: ("url(" + (_vm.topicItem.faceUrl && _vm.topicItem.faceUrl.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')) + ")")
    })
  }) : _vm._e(), _vm._v(" "), (_vm.topicItem.faceUrl === '') ? _c('div', {
    staticClass: "listHead_img1"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "listHead_name"
  }, [_c('p', {
    staticClass: "themeColor",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicItem.nickName || '缺少昵称'))
    }
  }), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm._f("parseDateTime")(_vm.topicItem.createTime)))])])])])])]) : _c('div', [_c('div', {
    attrs: {
      "id": "listHead1"
    }
  }, [_c('div', {
    staticClass: "listHead"
  }, [_c('div', {
    staticClass: "listHead_left"
  }, [(_vm.topicItem.faceUrl !== '' && _vm.topicItem.faceUrl && _vm.topicItem.faceUrl.length > 0) ? _c('div', {
    staticClass: "listHead_img",
    style: ({
      backgroundImage: ("url(" + (_vm.topicItem.faceUrl && _vm.topicItem.faceUrl.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')) + ")")
    })
  }) : _vm._e(), _vm._v(" "), (_vm.topicItem.faceUrl === '') ? _c('div', {
    staticClass: "listHead_img1"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "listHead_name"
  }, [_c('p', {
    staticClass: "themeColor",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicItem.nickName || '缺少昵称'))
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("parseDateTime")(_vm.topicItem.createTime)))])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discuss"
  }, [_c('div', {
    staticClass: "discuss-detail"
  }, [(_vm.limitImg == 9) ? _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    directives: [{
      name: "lazy-container",
      rawName: "v-lazy-container",
      value: ({
        selector: 'img'
      }),
      expression: "{ selector: 'img' }"
    }],
    staticStyle: {
      "height": "0.5rem"
    }
  }, [_c('img', {
    staticClass: "userImg",
    attrs: {
      "data-src": _vm.faceUrl,
      "alt": "",
      "data-error": _vm.errorImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info-right"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "nickName_createTime"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "0.1rem",
      "font-size": "0",
      "/*display": "flex",
      "align-items": "center"
    }
  }, [_c('p', {
    staticClass: "nickName",
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "bottom"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.nickName && _vm.discussItem.nickName.slice(0, 15)))
    }
  }), _vm._v(" "), (_vm.discussItem.isTop == 1) ? _c('svg', {
    staticClass: "is-top-style",
    attrs: {
      "viewBox": "0 0 2048 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M512 30.117647C246.964706 30.117647 30.117647 246.964706 30.117647 512s216.847059 481.882353 481.882353 481.882353h1024c265.035294 0 481.882353-216.847059 481.882353-481.882353S1801.035294 30.117647 1536 30.117647H512z m0-30.117647h1024c283.105882 0 512 228.894118 512 512s-228.894118 512-512 512H512C228.894118 1024 0 795.105882 0 512S228.894118 0 512 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M352.376471 397.552941H632.470588l3.011765-42.164706h-237.929412V219.858824h524.047059v135.529411h-234.917647l-3.011765 42.164706h289.129412v39.152941h-292.141176c-3.011765 15.058824-6.023529 27.105882-9.035295 42.164706h210.82353v319.247059h105.411765v42.164706H340.329412v-42.164706h105.411764V478.870588h174.682353c3.011765-15.058824 6.023529-27.105882 9.035295-42.164706h-274.070589v-39.152941z m141.552941 400.564706h334.305882v-48.188235H493.929412v48.188235z m0-81.317647h334.305882v-45.176471H493.929412v45.176471z m0-78.305882h334.305882v-45.176471H493.929412v45.176471z m0-78.305883h334.305882v-45.17647H493.929412v45.17647z m382.494117-240.941176v-60.235294h-108.423529v60.235294h108.423529z m-156.611764 0v-60.235294h-114.447059v60.235294h114.447059z m-162.635294 0v-60.235294H451.764706v60.235294h105.411765z m783.058823-96.376471h364.42353v51.2h-159.62353c-3.011765 27.105882-6.023529 51.2-9.035294 75.294118h144.564706V692.705882h-51.2v-295.152941h-219.858824V692.705882h-51.2V349.364706h123.482353c3.011765-24.094118 6.023529-51.2 9.035294-75.294118h-153.6V222.870588z m240.941177 472.847059c51.2 39.152941 96.376471 81.317647 132.517647 120.470588l-36.141177 39.152941c-33.129412-39.152941-75.294118-81.317647-129.505882-126.494117l33.129412-33.129412z m-87.341177-256h51.2v129.505882c-3.011765 75.294118-21.082353 138.541176-57.223529 183.717647-36.141176 42.164706-93.364706 75.294118-174.682353 99.388236l-27.105883-45.176471c78.305882-21.082353 129.505882-51.2 162.635295-90.352941 30.117647-39.152941 45.176471-87.341176 45.17647-150.588235v-126.494118zM1165.552941 846.305882H1084.235294l-12.047059-48.188235c27.105882 0 51.2 3.011765 75.294118 3.011765 18.070588 0 27.105882-12.047059 27.105882-30.117647V274.070588h-111.435294V222.870588h252.988235v51.2h-87.341176V783.058824c0 42.164706-21.082353 63.247059-63.247059 63.247058z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "createTime"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    domProps: {
      "textContent": _vm._s(_vm.parseDateTime(_vm.discussItem.createTime))
    }
  }), _vm._v(" "), (_vm.ipSwitch == 1 && _vm.discussItem.ip) ? _c('span', {
    staticStyle: {
      "display": "inline-block"
    },
    domProps: {
      "textContent": _vm._s(!_vm.discussItem.ipAddress && 'IP：未知' || 'IP：' + _vm.discussItem.ipAddress)
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('commentOperation', {
    attrs: {
      "item": _vm.discussItem,
      "isDetail": _vm.limitImg
    },
    on: {
      "detailShowPopover": _vm.detailShowPopover
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.limitImg == 3) ? _c('div', {
    staticClass: "user-info user-info-3"
  }, [_c('div', {
    directives: [{
      name: "lazy-container",
      rawName: "v-lazy-container",
      value: ({
        selector: 'img'
      }),
      expression: "{ selector: 'img' }"
    }],
    staticStyle: {
      "height": "0.5rem"
    }
  }, [_c('img', {
    staticClass: "userImg",
    attrs: {
      "data-src": _vm.faceUrl,
      "alt": "",
      "data-error": _vm.errorImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info-right",
    staticStyle: {
      "height": "0.5rem"
    }
  }, [_c('p', {
    staticClass: "nickName",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.nickName && _vm.discussItem.nickName.slice(0, 15)))
    }
  }), _vm._v(" "), (_vm.discussItem.isTop == 1) ? _c('svg', {
    staticClass: "is-top-style",
    staticStyle: {
      "display": "block",
      "line-height": "normal",
      "height": "auto"
    },
    attrs: {
      "viewBox": "0 0 2048 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M512 30.117647C246.964706 30.117647 30.117647 246.964706 30.117647 512s216.847059 481.882353 481.882353 481.882353h1024c265.035294 0 481.882353-216.847059 481.882353-481.882353S1801.035294 30.117647 1536 30.117647H512z m0-30.117647h1024c283.105882 0 512 228.894118 512 512s-228.894118 512-512 512H512C228.894118 1024 0 795.105882 0 512S228.894118 0 512 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M352.376471 397.552941H632.470588l3.011765-42.164706h-237.929412V219.858824h524.047059v135.529411h-234.917647l-3.011765 42.164706h289.129412v39.152941h-292.141176c-3.011765 15.058824-6.023529 27.105882-9.035295 42.164706h210.82353v319.247059h105.411765v42.164706H340.329412v-42.164706h105.411764V478.870588h174.682353c3.011765-15.058824 6.023529-27.105882 9.035295-42.164706h-274.070589v-39.152941z m141.552941 400.564706h334.305882v-48.188235H493.929412v48.188235z m0-81.317647h334.305882v-45.176471H493.929412v45.176471z m0-78.305882h334.305882v-45.176471H493.929412v45.176471z m0-78.305883h334.305882v-45.17647H493.929412v45.17647z m382.494117-240.941176v-60.235294h-108.423529v60.235294h108.423529z m-156.611764 0v-60.235294h-114.447059v60.235294h114.447059z m-162.635294 0v-60.235294H451.764706v60.235294h105.411765z m783.058823-96.376471h364.42353v51.2h-159.62353c-3.011765 27.105882-6.023529 51.2-9.035294 75.294118h144.564706V692.705882h-51.2v-295.152941h-219.858824V692.705882h-51.2V349.364706h123.482353c3.011765-24.094118 6.023529-51.2 9.035294-75.294118h-153.6V222.870588z m240.941177 472.847059c51.2 39.152941 96.376471 81.317647 132.517647 120.470588l-36.141177 39.152941c-33.129412-39.152941-75.294118-81.317647-129.505882-126.494117l33.129412-33.129412z m-87.341177-256h51.2v129.505882c-3.011765 75.294118-21.082353 138.541176-57.223529 183.717647-36.141176 42.164706-93.364706 75.294118-174.682353 99.388236l-27.105883-45.176471c78.305882-21.082353 129.505882-51.2 162.635295-90.352941 30.117647-39.152941 45.176471-87.341176 45.17647-150.588235v-126.494118zM1165.552941 846.305882H1084.235294l-12.047059-48.188235c27.105882 0 51.2 3.011765 75.294118 3.011765 18.070588 0 27.105882-12.047059 27.105882-30.117647V274.070588h-111.435294V222.870588h252.988235v51.2h-87.341176V783.058824c0 42.164706-21.082353 63.247059-63.247059 63.247058z"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.limitImg == 3) ? _c('div', {
    staticClass: "content list-content"
  }, [(_vm.discussItem.source == 1 && _vm.discussItem.aid > 0) ? _c('a', {
    style: ({
      '-webkit-line-clamp': (_vm.discussItem._picsLength > 0 ? 2 : 4)
    }),
    attrs: {
      "href": _vm.articleJumpUrl(25, _vm.discussItem.aid)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.content))
    }
  }) : _c('router-link', {
    style: ({
      '-webkit-line-clamp': (_vm.discussItem._picsLength > 0 ? 2 : 4)
    }),
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.discussItem.discussID,
          topicItem: _vm.discussItem
        }
      }
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.content))
    }
  })], 1) : _c('div', {
    staticClass: "content",
    style: ({
      '-webkit-line-clamp': (_vm.discussItem._picsLength > 2 ? 2 : 4)
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.content))
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discussItem._picsLength > 0),
      expression: "discussItem._picsLength>0"
    }],
    staticClass: "content content-images clearfix",
    class: {
      'more_two': _vm.discussItem._picsLength > 1
    }
  }, _vm._l((_vm.discussItem.attUrls && _vm.discussItem.attUrls.pics), function(item, index) {
    return (index < _vm.limitImg) ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.url),
        expression: "item.url"
      }],
      style: ({
        width: _vm.discussItem._picsWidth,
        height: _vm.discussItem._picsHeight
      }),
      attrs: {
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.detailShowSwiper(index)
        }
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discussItem._videosLength > 0),
      expression: "discussItem._videosLength>0"
    }],
    staticClass: "content content-video"
  }, [_c('video', {
    style: ({
      height: _vm.discussItem._videosHeight
    }),
    attrs: {
      "controls": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "x5-video-player-type": "h5-page",
      "src": _vm.discussItem.attUrls && _vm.discussItem.attUrls.videos && _vm.discussItem.attUrls.videos[0] && _vm.discussItem.attUrls.videos[0].url,
      "poster": _vm.discussItem.attUrls && _vm.discussItem.attUrls.videoPics && _vm.discussItem.attUrls.videoPics[0] && _vm.discussItem.attUrls.videoPics[0].url,
      "controlsList": (_vm.isAndroidApp && 'nofullscreen' || '')
    }
  })]), _vm._v(" "), (_vm.limitImg == 3 && _vm.discussItem.source == 1 && _vm.discussItem.aid > 0) ? _c('div', {
    staticClass: "members-contribute"
  }, [_c('a', {
    staticClass: "members-contribute-inner",
    attrs: {
      "href": _vm.articleJumpUrl(25, _vm.discussItem.aid)
    }
  }, [(_vm.discussItem.attUrls && _vm.discussItem.attUrls.pics && _vm.discussItem.attUrls.pics[0] && _vm.discussItem.attUrls.pics[0].url) ? _c('img', {
    attrs: {
      "src": _vm.discussItem.attUrls.pics[0].url,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.parseSpace(_vm.discussItem.title))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitImg == 3) ? _c('div', {
    staticClass: "createTime-comment-operation"
  }, [_c('p', {
    staticClass: "createTime"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    domProps: {
      "textContent": _vm._s(_vm.parseDateTime(_vm.discussItem.createTime))
    }
  }), _vm._v(" "), (_vm.ipSwitch == 1 && _vm.discussItem.ip) ? _c('span', {
    staticStyle: {
      "display": "inline-block"
    },
    domProps: {
      "textContent": _vm._s(!_vm.discussItem.ipAddress && 'IP：未知' || 'IP：' + _vm.discussItem.ipAddress)
    }
  }) : _vm._e()]), _vm._v(" "), _c('commentOperation', {
    attrs: {
      "item": _vm.discussItem,
      "isDetail": _vm.limitImg
    },
    on: {
      "detailShowPopover": _vm.detailShowPopover
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.limitImg == 3 && _vm.discussItem._picsLength > 3 && !(_vm.discussItem.source == 1 && _vm.discussItem.aid > 0)) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.discussItem.discussID,
          topicItem: _vm.discussItem
        }
      }
    }
  }, [_c('div', {
    staticClass: "listContent_tip"
  }, [_c('div', {
    staticClass: "listContent_tip_inner"
  }, [_c('span', [_vm._v("更多精彩内容，看详情")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyAgIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjEyOCIgaGVpZ2h0PSIxMjgiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTY3Ni41Nzk1NTYgNTExLjI2MDQ0NGwtMzkwLjI1Nzc3OC0zOTAuMjI5MzMzYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAxIDEgNDAuMjQ4ODg5LTQwLjIyMDQ0Mzk5TDczNi45MTAyMjE5OSA0OTEuMTUwMjIyYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAwIDEgMWUtOCA0MC4yMjA0NDVMMzI2LjU3MDY2NyA5NDEuNzEwMjIyMDFhMjguNDQ0NDQ0IDI4LjQ0NDQ0NCAwIDAgMS00MC4yMjA0NDUtNDAuMjIwNDQ0MDFMNjc2LjU3OTU1NiA1MTEuMjYwNDQ0eiIgIGZpbGw9IiM5OTk5OTkiPjwvcGF0aD48L3N2Zz4=",
      "alt": ""
    }
  })])])]) : _vm._e()], 1), _vm._v(" "), (_vm.limitImg === 9) ? _c('praiseDanner', {
    attrs: {
      "discussItem": _vm.discussItem
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list.length > 0) ? _c('div', [_c('swiper', {
    ref: "mySwiperad",
    staticClass: "swiper-Container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('a', {
      staticClass: "swiper-Container-a",
      attrs: {
        "href": item.contentUrl || '##'
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })])])
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "touchList",
    attrs: {
      "id": "touchList"
    }
  }, [_c('head-top', {
    attrs: {
      "appName": _vm.appName,
      "attention": _vm.attention,
      "bg": _vm.topicInfo.imgUrl,
      "sid": _vm.sid,
      "themeColor": _vm.themeColor,
      "topicID": _vm.topicID,
      "topicInfo": _vm.topicInfo,
      "uid": _vm.uid,
      "shareData": _vm.shareData
    },
    on: {
      "topicToApp": _vm.topicToApp
    }
  }), _vm._v(" "), _c('list', {
    attrs: {
      "sid": _vm.sid,
      "themeColor": _vm.themeColor,
      "topicID": _vm.topicID
    },
    on: {
      "showPopover": _vm.showPopover,
      "topicShowSwiper": _vm.topicShowSwiper
    }
  }), _vm._v(" "), _c('bottomOpenApp', {
    attrs: {
      "sid": _vm.sid,
      "themeColor": _vm.themeColor
    },
    on: {
      "topicToApp": _vm.topicToApp
    }
  }), _vm._v(" "), (_vm.popoverShow == 0) ? _c('Popover', {
    attrs: {
      "appName": _vm.appName,
      "istopiclist": 1
    },
    on: {
      "showPopover": _vm.showPopover,
      "topicToApp": _vm.topicToApp
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "topicInfos",
    staticClass: "topicInfo",
    attrs: {
      "id": "topicInfo"
    }
  }, [_c('topBanner', {
    attrs: {
      "appName": _vm.appName,
      "topicInfo": _vm.topicInfo
    },
    on: {
      "headToApp": _vm.headToApp
    }
  }), _vm._v(" "), (_vm.topicDetailType === 1) ? _c('div', [_c('div', {
    staticClass: "topicInfo_back",
    style: (_vm.styleComputed),
    attrs: {
      "id": "topicInfo_back"
    }
  }, [_c('div', {
    staticClass: "topicInfo_head"
  }, [_c('div', {
    staticClass: "topicInfo_text"
  }, [_c('div', {
    staticClass: "topicInfo_title",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.title))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.description))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "topicInfo_button",
    class: {
      'cxjrbClass': _vm.showSubmit == 1
    },
    attrs: {
      "id": "topicInfo_button"
    }
  }, [(_vm.attention) ? _c('div', {
    staticClass: "topicInfo_btn themeBgColor openappAndroidwx",
    on: {
      "click": _vm.alertLogin
    }
  }, [_vm._v(_vm._s(_vm.isAppName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.attention === false) ? _c('div', {
    staticClass: "topicInfo_btn openappAndroidwx",
    on: {
      "click": _vm.alertLogin
    }
  }, [_vm._v("未关注")]) : _vm._e()])])]), _vm._v(" "), (_vm.alertShow) ? _c('div', {
    staticClass: "alert-modal"
  }, [_c('div', {
    staticClass: "alert-hd"
  }, [_c('div', [_vm._v("请登录客户端！")]), _vm._v(" "), _c('div', {
    staticClass: "alert-cancle",
    on: {
      "click": _vm.alertCancle
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "alert-sure openappAndroidwx",
    on: {
      "click": _vm.alertSure
    }
  }, [_vm._v("确定")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.topicDetailType === 2) ? _c('div', {
    staticClass: "topicDetailType2"
  }, [(this.bg) ? _c('div', {
    staticClass: "topicDetailType2-img"
  }, [_c('img', {
    attrs: {
      "src": ("" + (this.bg.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com'))),
      "alt": ""
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (1) ? _c('div', [_c('swiperAd', {
    attrs: {
      "sid": _vm.sid,
      "topicID": _vm.topicID,
      "uid": _vm.uid
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.topicInfo.isShowAllTopics == 1) ? _c('div', {
    staticClass: "previous-topics-main"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.topicDetailType === 1) ? _c('div', {
    staticClass: "topicInfo_foot"
  }, [_c('div', {
    staticClass: "interest"
  }, [(_vm.topicInfo.interestCount > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("parseCount")(_vm.topicInfo.interestCount)) + "人关注")]) : _vm._e(), _vm._v(" "), (_vm.topicInfo.topicCount > 0) ? _c('span', {
    staticClass: "t-line"
  }) : _vm._e(), _vm._v(" "), (_vm.topicInfo.topicCount > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("parseCount")(_vm.topicInfo.topicCount)) + "参与 ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "endTime"
  }, [_vm._v(_vm._s(_vm.timeShow))])]) : _vm._e(), _vm._v(" "), (_vm.topicDetailType === 2) ? _c('div', {
    staticClass: "topicDetailType2-head"
  }, [_c('div', {
    staticClass: "topicDetailType2-title",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.title))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "topicDetailType2-status"
  }, [(_vm.topicInfo.interestCount > 0) ? _c('span', {
    staticStyle: {
      "margin-right": "0.3rem"
    }
  }, [_vm._v(_vm._s(_vm._f("parseCount")(_vm.topicInfo.interestCount)) + "人关注")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "endTime"
  }, [_vm._v(_vm._s(_vm.timeShow))])]), _vm._v(" "), (_vm.topicInfo.description) ? _c('div', {
    staticClass: "topicDetailType2-des",
    class: {
      topicDetailType2DesDown: _vm.showMoreDesClass
    }
  }, [_c('div', {
    staticClass: "des-content",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.description))
    }
  }), _vm._v(" "), (_vm.showMoreDes) ? _c('span', {
    staticClass: "downArea",
    on: {
      "click": function($event) {
        _vm.showMoreDesChange()
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0",
      "position": "relative"
    }
  }, [_c('div', {
    ref: "desBoxss",
    staticStyle: {
      "position": "absolute",
      "z-index": "-11",
      "visibility": "hidden"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicInfo.description))
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showSubmit) ? _c('div', {
    staticStyle: {
      "width": "0",
      "height": "0"
    },
    attrs: {
      "id": "submit-topic"
    }
  }, [_c('div', {
    staticClass: "submit-topic openappAndroidwx wx-launch-app-btn-parent",
    class: this.isWx && 'iswx',
    on: {
      "click": function($event) {
        _vm.submitHref()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAiCAMAAADiW5DOAAAAkFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+WABnwAAAAL3RSTlMA+8WArgXks1geGBDQyKGNFAz28OvClV86Jhzo4b65pmpIQCrbp6NTUALYfHdzM59y9XAAAAEjSURBVDjLjdHXkoJQEEXRbkBwSGZAzFkn7f//uwG1kCq4OOt5U4fqKzVBP5m5Y8aulfQDabPzlBf1do0iiygtZs7ZmbmUokzqegMFXae5POTpWkEHPakEM+A0l7r5GbCGVRKCu2/M75cQBs+h1f2DpqEFq8ecDdFI2owisO/DysKXdr6Llr+5gYuYXOFUpEokZhbqyxb6YtaHrTjoSMxGiiNHQukScpRx0XVxGAtspMuvpzLBk25bCfmUd2LwjcexqgP8iAE8DzBh2XvTyAC+3jXDKZqZm+qPpofmW1as51oRdTe3GOzOrcLHv5thEqeH8gw9Y7NbUNCJO9Hv9maQUONlr7d4NQpq5xc79tZObF99qVRNYbmXLjmwCaTTbTVNxewPF/YoLOzIc4wAAAAASUVORK5CYII=",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("我要参与")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previous-topics openappAndroidwx wx-launch-app-btn-parent"
  }, [_c('span', [_vm._v("往期话题")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik02NzYuNTc5NTU2IDUxMS4yNjA0NDRsLTM5MC4yNTc3NzgtMzkwLjIyOTMzM2EyOC40NDQ0NDQgMjguNDQ0NDQ0IDAgMSAxIDQwLjI0ODg4OS00MC4yMjA0NDM5OUw3MzYuOTEwMjIxOTkgNDkxLjE1MDIyMmEyOC40NDQ0NDQgMjguNDQ0NDQ0IDAgMCAxIDFlLTggNDAuMjIwNDQ1TDMyNi41NzA2NjcgOTQxLjcxMDIyMjAxYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAwIDEtNDAuMjIwNDQ1LTQwLjIyMDQ0NDAxTDY3Ni41Nzk1NTYgNTExLjI2MDQ0NHoiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD48L3N2Zz4=",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "arrowTip"
  }, [_c('span')])
}]}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "praise-banner"
  }, [(_vm.discussItem.curClass != 'news_comment_praise_img_active') ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 85 85"
    },
    on: {
      "click": function($event) {
        _vm.clickPares(_vm.discussItem.curClass == 'news_comment_praise_img_active' ? '' : _vm.discussItem, 1)
      }
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "stroke-width": "2px",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "fill": "none",
      "d": "M42.000,1.000 C64.644,1.000 83.000,19.356 83.000,42.000 C83.000,64.644 64.644,83.000 42.000,83.000 C19.356,83.000 1.000,64.644 1.000,42.000 C1.000,19.356 19.356,1.000 42.000,1.000 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M61.007,33.713 L47.838,33.713 C47.355,33.713 47.541,33.403 48.429,31.333 C49.189,29.560 49.632,28.327 49.687,26.581 C49.806,22.791 47.719,18.176 44.653,18.260 C39.362,18.407 39.973,21.537 39.067,25.205 C38.266,28.431 37.028,31.939 34.589,33.713 C32.199,34.600 34.314,34.902 25.781,34.902 C24.180,34.902 23.264,35.916 23.264,37.278 L23.260,58.903 C23.260,60.301 23.749,61.034 25.526,61.034 L57.039,61.049 C57.244,61.049 58.533,60.947 59.352,60.484 C60.773,59.681 61.009,58.673 61.009,58.673 L66.041,38.468 C66.030,36.809 64.786,33.710 61.009,33.710 L61.007,33.713 L61.007,33.713 ZM25.784,58.673 L25.784,37.278 C25.784,37.278 28.978,37.297 30.817,37.293 L30.817,58.673 L25.781,58.673 L25.784,58.673 L25.784,58.673 ZM63.526,38.466 C63.408,38.941 58.495,57.482 58.495,57.482 C58.115,58.284 58.052,58.673 57.235,58.673 L33.331,58.673 L33.331,36.960 C34.255,36.674 35.328,36.284 35.849,36.089 C38.241,34.329 39.346,32.257 40.882,28.957 C42.417,25.665 41.127,20.926 44.656,20.638 C45.913,20.536 47.709,23.840 47.172,26.581 C46.092,32.090 44.929,31.653 44.656,33.713 C44.656,34.823 45.921,36.089 47.172,36.089 L61.009,36.089 C62.910,36.089 63.712,37.743 63.526,38.468 L63.526,38.466 L63.526,38.466 Z"
    }
  })]) : _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 85 85"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "fill": "",
      "d": "M60.927,33.576 L47.693,33.576 C47.208,33.576 47.396,33.266 48.286,31.190 C49.051,29.411 49.497,28.175 49.552,26.424 C49.671,22.625 47.574,17.996 44.493,18.080 C39.176,18.228 39.791,21.367 38.880,25.045 C38.075,28.280 36.832,31.797 34.379,33.576 C31.979,34.466 34.103,34.769 25.529,34.769 C23.922,34.769 23.000,35.786 23.000,37.152 L22.996,58.836 C22.996,60.237 23.488,60.973 25.274,60.973 L56.940,60.988 C57.145,60.988 58.441,60.886 59.263,60.423 C60.690,59.616 60.929,58.604 60.929,58.604 L65.986,38.345 C65.973,36.682 64.723,33.574 60.929,33.574 L60.927,33.576 L60.927,33.576 ZM33.117,60.991 L30.590,60.991 L30.590,34.676 C30.590,34.676 32.268,34.692 33.117,34.178 L33.117,60.991 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "stroke": "",
      "stroke-width": "2px",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "fill": "none",
      "d": "M42.000,1.000 C64.644,1.000 83.000,19.356 83.000,42.000 C83.000,64.644 64.644,83.000 42.000,83.000 C19.356,83.000 1.000,64.644 1.000,42.000 C1.000,19.356 19.356,1.000 42.000,1.000 Z"
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discussItem.praiseCount > 0),
      expression: "discussItem.praiseCount>0"
    }]
  }, [_vm._v(_vm._s(_vm._f("parseCount")(_vm.discussItem.praiseCount)))])])
},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiperContainer",
    attrs: {
      "options": _vm.swiperOption
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "swiper-zoom-container"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.urlOriginal || item.url),
        expression: "item.urlOriginal || item.url"
      }],
      attrs: {
        "lazy": "loading",
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    attrs: {
      "topicInfo": _vm.topicInfo,
      "topicID": _vm.topicID,
      "sid": _vm.sid,
      "uid": _vm.uid,
      "bg": _vm.topicInfo.imgUrl,
      "govImage": _vm.govImage,
      "attention": _vm.attention,
      "themeColor": _vm.themeColor,
      "appName": _vm.appName
    },
    on: {
      "downApp": _vm.downApp,
      "showSwiper": _vm.showSwiper
    }
  }), _vm._v(" "), (_vm.isShowSwiper) ? _c('swiper', {
    attrs: {
      "items": _vm.pics,
      "initIndex": _vm.initIndex
    },
    on: {
      "close": _vm.closeImg
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-box",
    class: {
      'istopiclist': _vm.istopiclist === 1
    }
  }, [_c('div', {
    staticClass: "p-b-inner"
  }, [_c('div', {
    staticClass: "p-b-i-top"
  }, [_vm._v("\n      " + _vm._s(_vm.popoverContent) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "p-b-i-bottom"
  }, [_c('div', {
    staticClass: "p-b-i-b-ensure openappAndroidwx wx-launch-app-btn-parent"
  }, [_vm._v("\n        确定\n      ")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.clickCancel()
      }
    }
  }, [_vm._v("\n        取消\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listContent"
  }, [(!_vm.isShare) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.discussID,
          topicItem: _vm.topicItem
        }
      }
    }
  }, [_c('div', {
    class: _vm.contC,
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.content))
    }
  })]), _vm._v(" "), (_vm.isImgShow && _vm.attUrls.pics) ? _c('div', {
    class: _vm.imgContainer
  }, _vm._l((_vm.attUrls.pics), function(img, imgindex) {
    return _c('img', {
      key: img,
      class: _vm.imgC,
      attrs: {
        "src": ("" + (img.url.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')))
      },
      on: {
        "click": function($event) {
          _vm.bigImage(imgindex)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.discussID,
          topicItem: _vm.topicItem
        }
      }
    }
  }, [(_vm.isTipShow) ? _c('div', {
    staticClass: "listContent_tip themeColor"
  }, [_vm._v("更多精彩内容，看详情")]) : _vm._e()])], 1) : _c('div', [_c('div', [_c('div', {
    class: _vm.contC,
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.content))
    }
  })]), _vm._v(" "), (_vm.isImgShow && _vm.attUrls.pics) ? _c('div', {
    class: _vm.imgContainer
  }, _vm._l((_vm.attUrls.pics), function(img, imgindex) {
    return _c('img', {
      key: img,
      class: _vm.imgC,
      attrs: {
        "src": ("" + (img.url.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')))
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.openHrefApp
    }
  }, [(_vm.isTipShow) ? _c('div', {
    staticClass: "listContent_tip themeColor"
  }, [_vm._v("更多精彩内容 请下载客户端查看")]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showSubmit == 1) ? _c('div', {
    staticClass: "live_input"
  }, [_c('div', {
    staticClass: "live_input_content",
    on: {
      "click": function($event) {
        _vm.submitComment()
      }
    }
  }, [_vm._v(" 写点评论吧..")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bannerShow),
      expression: "bannerShow"
    }],
    staticClass: "bottom-open-app",
    attrs: {
      "id": "bottomOpenApp"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "id": "contentImg",
      "src": _vm.iconImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    ref: "btnOpenAppBanner",
    staticStyle: {
      "float": "right",
      "width": "100%",
      "margin": "10px 0",
      "text-align": "right"
    },
    attrs: {
      "id": "btnOpenAppBanner"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right",
      "width": "18px",
      "height": "18px",
      "margin-top": "7px"
    },
    attrs: {
      "id": "bottomCloseImg",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAV1BMVEUAAACqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqpHJnhUAAAAHHRSTlMA1BX6JAwHxzPrnJn12sGJV+l2PCW7tZ6qqWseIX1HXgAAARVJREFUOMuFU1uSgzAMU+KEJLzfbFvd/5w72/WU0NJBP0wsBxkjYYfvqzCIDKHqPT7hypov1KV7o4tOyHacbFHYaWxJ6YrDdUNu836eN9JkL4kDm4gDYsPhVXKJy8dYtmVyqm/YHgS1vND8lzs2FifwDbungDDiFJHyJ1JywxdsLAFfU2e5BVWy4abTs/bo2Wp/oLFP3jBoqWWPiiMAJYzVh5ZGVgickHfkPCYGJFrkHcprgQnCAnlHzqOgXDZcSlwOefmZ14vaV/2zr/onWzVKljiHUk7k2+8WmdUw/qth1HLrmeVWGv8y7eo/7q9M7tL2eXCkeuznRyU07j16styjB3y8L6LRyzEfw7vn8Bj/JJKO8f8FTVwUKr7FB8oAAAAASUVORK5CYII="
    },
    on: {
      "click": function($event) {
        _vm.closeShow()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-open themeBgColor openappAndroidwx wx-launch-app-btn-parent",
    attrs: {
      "id": "btnOpenAppSpan"
    }
  }, [_vm._v("打开")])])])])
},staticRenderFns: []}

/***/ })
],[183]);


// WEBPACK FOOTER //
// assets/js/app.d45653627b1827aa7531.js